type DictionaryArrtype = {
	title: string;
	content: string[];
};

export const alphabet = [
	'A',
	'B',
	'C',
	'D',
	'E',
	'F',
	'G',
	'H',
	'I',
	'J',
	'K',
	'L',
	'M',
	'N',
	'O',
	'P',
	'Q',
	'R',
	'S',
	'T',
	'U',
	'V',
	'W',
	'X',
	'Y',
	'Z',
];

export const dictionaryArr: DictionaryArrtype[] = [
	{
		title: 'Acreage',
		content: [
			'Land leased for oil and gas exploration and/or land for which ConocoPhillips owns the mineral rights',
		],
	},
	{
		title: 'American Petroleum Institute (API)',
		content: [
			'The American Petroleum Institute is the oil and gas industry’s trade organization. API’s research and engineering work provides a basis for establishing operating and safety standard issues and specifications for the manufacturing of oil field equipment and furnishes statistical and other information to related agencies.',
		],
	},
	{
		title: 'Anticline',
		content: [
			'A convex-upward formation of rock layers, which may form a trap for hydrocarbons.',
		],
	},
	{
		title: 'Aquifer',
		content: [
			'An underground layer of water-bearing permeable rock or unconsolidated materials (gravel, sand, silt or clay) from which groundwater can be extracted using a water well.',
		],
	},
	{
		title: 'Abandonment',
		content: [
			'Permission given to US interstate pipelines by the Federal Regulatory Energy Commission (FERC) allowing for the discontinuation of sales, storage, or transportation service along any portion of the pipeline system. FERC permission is sought when utility companies want to replace, update or sell their facilities.',
		],
	},
	{
		title: 'Abandonment Rule (Order 490)',
		content: [
			'A FERC rule that allows producers and their pipeline purchasers with pre-granted “blanket” authority to abandon sales when the contract has expired or has been mutually renegotiated. It also allows the abandonment of an expired or renegotiated contract between one pipeline and another.',
		],
	},
	{
		title: 'Above-market cost',
		content: [
			'• When the cost charged for a given commodity is higher than the going rate for that commodity in the open market, the difference between the actual price paid and the open market rate is referred to as the abovemarket cost.',
			'• The term refers to the amount over and above the market rate, not the whole cost.',
		],
	},
	{
		title: 'Access charge, wires charge',
		content: [
			'• A fee charged for the right to send or receive power over another party’s distribution system. This fee, which is usually levied on a producer, supplier, or customer, serves as a type of rental or user fee charged for the use of the energy transmission infrastructure used to transmit energy to the customer.',
			'• In regulated markets, access charges may be bundled into charges for energy used by the customer.',
			'• In deregulated markets, access charges usually appears as a separate line item on energy invoices.',
			'• Wires charges are usually billed at a cents-per-kilowatt-hour rate, which is typically set by regional legislatures. (Note: This situation is likely to change as the energy transmission infrastructure becomes more heavily privatised.)',
			'• The fees collected from access charges are used to defray costs for infrastructure (power lines, distribution stations, maintenance, etc) as well as less obvious costs such as stranded costs, securitised debt, taxes, franchise fees, development costs for renewable energy and environmental programs, public benefits programs (eg, education/public relations, support for lowincome consumers) and a range of others.',
		],
	},
	{
		title: 'Accessible reserve base',
		content: [
			'• The portion of the demonstrated reserve base estimated by EIA to be accessible, determined by application of one or more accessibility factors within an area.',
			'• May be referred to as accessible resources because it is a subset of accessible resources and is usually part of a single resource study.',
		],
	},
	{
		title: 'Account Executive',
		content: [
			'An agent or broker representing a commission house, who generally takes and manages commodities futures and options orders, and often offers advice to trading clients. ',
		],
	},
	{
		title: 'Ad Valorem Tax',
		content: [
			'A charge levied on persons or organizations based on the value of transaction. It is normally a given percentage of the price at the retail or manufacturing stage and is a common form of sales tax (e.g. federal excise tax on new trucks and trailers). ',
		],
	},
	{
		title: 'ADP (Alternate Delivery Procedures)',
		content: [
			'A provision of many energy futures contracts that allows for both sides of the futures market to make deliveries under terms and conditions which differ markedly from those described by the strict delivery rules. ADP’s always occur following the expiration of contracts for the spot month, after deliveries have been matched. ',
		],
	},
	{
		title: 'Affiliated Marketer ',
		content: [
			'A marketing company that buys and resells gas and is owned either by an interstate pipeline, a local distribution company or a corporation that also owns either an interstate pipeline subsidiary or a local distribution company. ',
		],
	},
	{
		title: 'AGA (American Gas Association)',
		content: [
			'An industry trade group representing natural gas utility companies.',
		],
	},
	{
		title: 'Alcohol and Alcohol Blends',
		content: [
			'Family name of a group of organic chemical compounds composed of carbon, hydrogen and oxygen. Examples are methanol, ethanol and tertiary butyl alcohol. Alcohol and alcohol blends are added to gasoline in order to make it burn cleaner and boost octane. ',
		],
	},
	{
		title: 'Alkylate (Alkylation)',
		content: [
			'A refining operation that takes low value derivatives from the cat cracking and other processes and unites them in the presence of an acid catalyst to produce a very high octane, low vapor pressure gasoline blending component. ',
		],
	},
	{
		title: 'Alkylation Unit',
		content: [
			'An oil refining unit in which propylene or butylene reacts with iso-butylene to yield a high octane gasoline blending component called alkylate. Alkylate helps improve the environmental qualities of gasoline – low vapor pressure, zero sulfur content, zero olefin content, zero benzene and a high octane number. Allocation Method: The method of allocating volumes to affected parties for a variety of reasons.',
		],
	},
	{
		title: 'Allowance For Funds Used During Construction (AFUDC)',
		content: [
			'A component of construction costs representing the net cost of borrowed funds and a reasonable rate on other funds used during the period of construction. AFUDC is capitalized until the project is placed in operation by concurrent credits to the income statement and charges to utility plant, based generally on the amount expended to date on the particular project. Effective January 1, 1977, FERC amended the Uniform System of Accounts establishing formulas for maximum allowable AFUDC rates. ',
		],
	},
	{
		title: 'Allowed Rate of Return',
		content: [
			'The rate of return that a regulatory commission allows on a rate base in establishing just and reasonable rates for a utility. It is usually based on the composite cost of financing rate base from debt, preferred stock, and common equity.',
		],
	},
	{
		title: 'Annual Quantity Entitlement (AQE)',
		content: [
			'The quantity of gas a buyer or shipper has nominated to receive on an annual basis from a pipeline.',
		],
	},
	{
		title: 'Any Current Month',
		content: [
			'OPIS prices labeled as “any current month” represent transactions for product that buyer and seller agree will be delivered at any time during the current calendar month.',
		],
	},
	{
		title: 'Any Delivery (Any)',
		content: [
			'Spot market terminology for deliveries that can be made at any time during the month at the seller’s discretion. Spot market prices will often be tied to the delivery stipulations termed prompt, outer month, or any month. ',
		],
	},
	{
		title: 'American National Standards Institute (ANSI)',
		content: [
			'The coordinating organization for America’s federated national standards system. The ANSI federation consists of nine hundred companies, large and small, and some two hundred trade, technical, professional, labor, and consumer organizations.',
		],
	},
	{
		title: 'American Petroleum Institute (API)',
		content: [
			'A trade association comprised of integrated and mostly upstream oil companies that works for the common goals of the oil industry.',
		],
	},
	{
		title: 'API Gravity',
		content: [
			'Industry scale expressing the gravity or density of liquid petroleum products. The measuring scale is calibrated in terms of degrees API, it may be calculated in terms of the following formula: Degrees API = 141.5/sp.gr.60° F/60 °F -131.5 The higher the API gravity, the lighter the compound. Light crudes generally exceed 38 degrees API and heavy crudes are commonly labeled as all crudes with an API gravity of 22 degrees or below. Intermediate crudes fall in the range of 22 degrees to 38 degrees API gravity. Light crudes yield more gasoline.',
		],
	},
	{
		title: 'API Inventory Figures ',
		content: [
			'A widely monitored body of data in the petroleum industry. This report compiles changes in domestic petroleum production, imports, refining, capacity and product movements into and out of primary storage. Traders use this information to access supply and demand on a week-to-week basis. These figures are usually released Tuesday afternoons. The release of these reports is occasionally a catalyst for movement on the futures market.',
		],
	},
	{
		title: 'ARAMCO (Arabian American Oil Company)',
		content: [
			'A joint venture between Saudi Arabia and four American oil companies (Exxon, Mobil, Texaco and Chevron) formed to market Saudi Arabian crude production. ',
		],
	},
	{
		title: 'Arbitrage',
		content: [
			'The buying, selling, and exchange of petroleum products or crude oil in different markets with the express design to take advantage of location, product, and timing differentials. Traders looking to move U.S. Gulf Coast No. 2 oil to Rotterdam watch the arbitrage between Gulf Coast prices and the InterContinentalExchange, for example.',
		],
	},
	{
		title: 'Aromatics',
		content: [
			'Hydrocarbons characterized by their uniform carbon ring structure and their often pleasant aroma. Commercial petroleum aromatics are benzene, toluene, and xylene. These three are often referred to by the acronym BTX. These chemicals are used as high octane components in gasoline. Aromatics have been judged to be undesirable in some finished motor fuels with various state and federal regulations geared toward reducing their levels. CARB diesel fuel in the state of California mandates a low aromatics composition.',
		],
	},
	{
		title: 'As Billed Rates',
		content: [
			'A policy requiring pipelines to flow through gas costs to their customers in the same manner as they are billed to the pipeline.',
		],
	},
	{
		title: 'Asphalt',
		content: [
			'A dark-brown-to-black cement-like material containing bitumens as the predominant constituent obtained by petroleum processing, used primarily for road construction. It includes crude asphalt as well as the following finished products: cements, fluxes, the asphalt content of emulsions (exclusive of water), and petroleum distillates blended with asphalt to make cutback asphalts. Note: The conversion factor for asphalt is 5.5 barrels per short ton.',
		],
	},
	{
		title: 'American Society of Testing Materials (ASTM)',
		content: [
			'Grade and quality specifications for petroleum products are determined by ASTM test methods.',
		],
	},
	{
		title: 'Atmospheric Crude Oil Distillation',
		content: [
			'The refining process of separating crude oil components at atmospheric pressure by heating to temperatures of about 600 degrees Fahrenheit to 750 degrees Fahrenheit (depending on the nature of the crude oil and desired products) and subsequent condensing of the fractions by cooling.',
		],
	},
	{
		title: 'At the Market Order',
		content: [
			'Specifies buying or selling a futures/options contract as quickly as possible, at the best possible price. Gives the broker the discretion to use his expertise to execute the contract, regardless of where the market moves, between when the order is given and execution is made.',
		],
	},
	{
		title: 'At the Money Option',
		content: [
			'Refers to the state which may briefly exist when the options strike price and the futures price intersect. A 60cts/gal December call or put is “at the money” when the futures price is at 60cts/gal.',
		],
	},
	{
		title: 'Aviation Gasoline (Finished)',
		content: [
			'A complex mixture of relatively volatile hydrocarbons with or without small quantities of additives, blended to form a fuel suitable for use in aviation reciprocating engines. Fuel specifications are provided in ASTM Specification D 910 and Military Specification MIL-G-5572.',
			'Note:',
			'Data on blending components are not counted in data on finished aviation gasoline. Generally a high octane gasoline.',
		],
	},
	{
		title: 'Aviation Gasoline Blending Components',
		content: [
			'Naphthas which will be used for blending or compounding into finished aviation gasoline (e.g., straight-run gasoline, alkylate, reformate, benzene, toluene, and xylenes). Excludes oxygenates (alcohols, ethers), butanes, and pentanes. Oxygenates are reported as other hydrocarbons, hydrogen, and oxygenates. ',
		],
	},
	{
		title: 'Automated Meter Reading (AMR)',
		content: [
			'“Real-time” monitoring of natural gas quantities and characteristics as it passes through a specific location. This is usually accomplished through the use of radio or telephone technologies.',
		],
	},
	{
		title: 'Backhaul',
		content: [
			'A transaction that results in the transportation of gas in a direction opposite of the aggregate physical flow of gas in the pipeline. This is typically achieved when the transporting pipeline redelivers gas at a point(s) upstream from the point(s) of receipt. A back haul condition will exist as long as the aggregate backhaul transactions total less than the aggregate forward haul transactions. A back haul transaction can result in a delivery by non-delivery or cut back (reduction) of physical flow at a delivery point. For refined oil products, a backhaul is simply the delivery of one product by tank truck, barge, or rail and the use of the vessel to transport back (back haul) another product. ',
		],
	},
	{
		title: 'Backwardation',
		content: [
			'Term that describes a market which features higher prices for prompt or near-term delivery than for forward or outer month(s) material. Also referred to as an inverted market, this scenario offers no incentive to store barrels.',
		],
	},
	{
		title: 'Balancing',
		content: [
			'The act of making receipts and deliveries of gas into or withdrawals from either an interstate gas pipeline or a local distribution company’s distribution system equal. Balancing may be accomplished daily, monthly or seasonally, with fees or penalties generally assessed for excessive imbalances. The purpose of balancing requirements is to prevent a shipper from tying up storage and line pack with excess deliveries of transportation gas, or from depleting storage and line pack by taking more gas off the system than it delivers, both of which disrupt other sales and transportation services.',
		],
	},
	{
		title: 'Balancing Agreement',
		content: [
			'A contractual agreement between two or more legal entities to account for differences between chart measured quantities and the total confirmed nominated quantities at a point. They have been used to keep track of over/under production relative to entitlements between producers, over/under deliveries relative to confirmed nominations between operators of wells, pipelines and LDCs.',
		],
	},
	{
		title: 'Balancing Tolerance',
		content: [
			'The amount of imbalance allowed by a utility which is not subject to a penalty charge. The imbalance tolerance is usually stated in a range expressed in percentage terms.',
		],
	},
	{
		title: 'Barrel',
		content: [
			'Term used as the standard measurement of volume for crude oil and large quantities of refined products in the petroleum industry. A unit of volume equal to 42 U.S. gallons – often abbreviated as bbl.',
		],
	},
	{
		title: 'Barrels Per Calendar Day',
		content: [
			'The amount of input that a distillation facility can process under usual operating conditions. The amount is expressed in terms of capacity during a 24-hour period and reduces the maximum processing capability of all units at the facility under continuous operation (see Barrels per Stream Day) to account for the following limitations that may delay, interrupt, or slow down production:',
			"● The capability of downstream facilities to absorb the output of crude oil processing facilities of a given refinery. No reduction is made when a planned distribution of intermediate streams through other than downstream facilities is part of a refinery's normal operation, the types and grades of inputs to be processed.",
			'● The types and grades of products expected to be manufactured, the environmental constraints associated with refinery operations, the reduction of capacity for scheduled downtime due to such conditions as routine inspection, maintenance, repairs, and turnaround.',
			'● The reduction of capacity for unscheduled downtime due to such conditions as mechanical problems, repairs, and slowdowns',
		],
	},
	{
		title: 'Barrel of oil equivalent (BOE)',
		content: [
			'A measure used to aggregate oil and gas resources or production, with one BOE being approximately equal to 6,000 cubic feet of natural gas',
		],
	},
	{
		title: 'Barrels Per Stream Day',
		content: [
			'The maximum number of barrels of input that a distillation facility can process within a 24-hour period when running at full capacity under optimal crude and product slate conditions with no allowance for downtime. ',
		],
	},
	{
		title: 'Basin',
		content: [
			'A large, natural depression on the Earth’s surface in which sediments, generally brought by water, accumulate.',
		],
	},
	{
		title: 'Base Gas',
		content: [
			'Gas in a storage reservoir which provides the pressure necessary for designed withdrawals of working gas. Also called cushion gas.',
		],
	},
	{
		title: 'Base Load',
		content: [
			'Market requirements that remain fairly constant over a period of time that usually are not temperature sensitive.',
		],
	},
	{
		title: 'Basis',
		content: [
			'The difference between the price of the actual commodity (e.g. heating oil) and the price of the futures contract. Basis can be calculated by subtracting the futures price from the cash price. For example, if N.Y. Harbor physical heating oil is 60cts/gal and the futures price is 61cts/gal, the basis is -1.00cts/ gal. Also called “basis differential.”',
		],
	},
	{
		title: 'Basis Risk',
		content: [
			'Price exposure associated with variation in the relationship between a physical or cash price and the appropriate NYMEX reference. These risks may be associated with location, product specifications, and time variations.',
		],
	},
	{
		title: 'Batch',
		content: ['A shipment of one type of product through a pipeline.'],
	},
	{
		title: 'Bear Market (Bearish)',
		content: [
			'A market in which prices are declining or are presumed to be in a declining trend.',
		],
	},
	{
		title: 'Benchmark Crude',
		content: [
			'A widely accepted grade of crude oil used as a standard in trading. Other grades would be traded at a price differential according to the quality differences. Examples would be WTI, Brent, Dubai and Arab Light.',
		],
	},
	{
		title: 'Benzene (C6H6)',
		content: [
			'An aromatic hydrocarbon present in small proportion in some crude oils and made commercially from petroleum by the catalytic reforming of naphthenes in petroleum naphtha. Also made from coal in the manufacture of coke. Used as a solvent, in manufacturing detergents, synthetic fibers, and petrochemicals and as a component of high-octane gasoline.',
		],
	},
	{
		title: 'Bid and Ask',
		content: [
			'Prices offered to buy and sell respectively, on spot market deals. An interested party can sell at the bid and buy at the asked price. Spot prices are not reported as a straight number, but rather, in terms of bid and ask. OPIS editors derive an appropriate price from those to report a value that’s representative of that market.',
		],
	},
	{
		title: 'Bid',
		content: [
			'Is what the buyer is willing to pay and ask is what the seller wants for the product.',
		],
	},
	{
		title: 'Biofuels',
		content: [
			'Any fuel derived by a variety of processes from an organic source that is renewable, i.e. capable of being replenished naturally.',
		],
	},
	{
		title: 'Blanket Certificate',
		content: [
			'Certificate issued by FERC which authorizes open access transportation by interstate pipeline companies on behalf of others and certain services by local distribution companies and Hinshaw companies under blanket certificates (of public convenience and necessity) subject to certain conditions and reporting requirements.',
		],
	},
	{
		title: 'Blending Plant',
		content: [
			'A facility which has no refining capability but is either capable of producing finished motor gasoline through mechanical blending or blends oxygenates with motor gasoline.',
		],
	},
	{
		title: 'Boiler',
		content: [
			'A closed vessel in which a liquid is heated and/or vaporized. Often classified as steam or hot water, low pressure or high pressure, capable of burning one fuel or a number of fuels.',
		],
	},
	{
		title: 'Boiler Efficiency',
		content: [
			'The ratio of the useful heat output to the heat input multiplied by 100 and expressed as a percent.',
		],
	},
	{
		title: 'Boiler Rating',
		content: [
			'The rating of a steam boiler expressed as the total heat transferred by the heating surfaces in Btu per hour. Sometimes also expressed in horsepower or pounds of steam per hour.',
		],
	},
	{
		title: 'Bonded Petroleum Imports',
		content: [
			'Petroleum imported and entered into Customs bonded storage. These imports are not included in the import statistics until they are: (1) withdrawn from storage free of duty for use as fuel for vessels and aircraft engaged in international trade, or (2) withdrawn from storage with duty paid for domestic use. Bonded fuel is typically exempt from import duties or fees.',
		],
	},
	{
		title: 'Bottoms',
		content: [
			'The heaviest components of petroleum product left in the refining process after the light ends have been removed. These products include asphalt, coke and residuals.',
		],
	},
	{
		title: 'Branded',
		content: [
			'Distinction of product that is sold under a trademark owned by a refiner (or reseller in some instances) and usually affiliated with integrated or major oil firms. Branded product often carries a premium to unbranded product, since it can be sold under a branded “flag.” Branded gasoline can be sold as unbranded product, but the reverse is not true, unless special licensing agreements are granted. Branded markers are most often proprietary additive packages to improve the quality and performance of a product.',
		],
	},
	{
		title: 'Branded Average',
		content: [
			'An average of all branded suppliers, denoted with a (b) in the OPIS rack display. Calculated on a gross or net price basis.',
		],
	},
	{
		title: 'Break',
		content: ['A rapid and sharp price decline.'],
	},
	{
		title: 'Broker',
		content: [
			'Anyone who executes futures or options contracts in exchange for a commission fee. The term can apply to account executives who take phone orders and pass the execution on to the floor. The term also applies to electronic brokers who execute orders on various platforms.',
		],
	},
	{
		title: 'BBL',
		content: [
			'One stock tank barrel, of 42 U.S. gallons liquid volume, used in reference to crude oil, bitumen, condensate or natural gas liquids.',
		],
	},
	{
		title: 'BCF',
		content: ['One billion cubic feet of natural gas.'],
	},
	{
		title: 'Bitumen',
		content: [
			'A highly viscous form of crude oil (greater than 10,000 centipoise) resembling cold molasses (at room temperature). Bitumen must be heated or combined with lighter hydrocarbons for it to be produced. Contains sulfur, metals and other nonhydrocarbons in its natural form.',
		],
	},
	{
		title: 'BOED',
		content: ['Barrels of oil equivalent per day.'],
	},
	{
		title: 'Borehole',
		content: ['A hole in the earth made by a drilling rig.'],
	},
	{
		title: 'British thermal unit (BTU)',
		content: [
			'The heat required to raise the temperature of a one-pound mass of water by one degree Fahrenheit.',
		],
	},
	{
		title: 'Brent',
		content: [
			'Blend of crude oil from a critical group of North Sea fields, Brent is the standard contract for ICE crude oil futures trading, and the most commonly referenced crude in Europe. It’s described as the European counterpart of WTI, and its morning performance is often a harbinger for the NYMEX opening. London’s ICE Brent contract is the benchmark crude for international oil physical and futures trading.',
		],
	},
	{
		title: 'British Thermal Unit (Btu)',
		content: [
			'The measure used to gauge the heating quality of various fuels. It is the amount of heat needed to increase the temperature of one pound of water one degree Fahrenheit from 58.5 to 59.5 degrees under standard pressure of 30 inches of mercury at or near its point of maximum density. General conversion factors are: 1 BTU = 252 calories,1,055 joules, or 0.293 watt hours.',
		],
	},
	{
		title: 'Btu, Dry',
		content: [
			'The heating value contained in a cubic foot of natural gas measured and calculated free of moisture content. Contractually, dry may be defined as less than or equal to 7 pounds of water per Mcf.',
		],
	},
	{
		title: 'Btu, Saturated (or Wet)',
		content: [
			'The number of Btus contained in a cubic foot of natural gas fully saturated with water under actual delivery pressure, temperature and gravity conditions.',
		],
	},
	{
		title: 'BTX',
		content: [
			'The acronym for the commercial petroleum aromatics benzene, toluene, and xylenes. See individual categories for definitions.',
		],
	},
	{
		title: 'Bulk Station',
		content: [
			'A facility used in the storage or marketing of petroleum products which has a total bulk storage of less than 50,000 barrels and receives product by tank car, or truck.',
		],
	},
	{
		title: 'Bulk Terminal',
		content: [
			'A facility used primarily for the storage and/or marketing of petroleum products which has a total bulk storage capacity of 50,000 bbls or more and/or receives petroleum products by tanker, barge or pipeline.',
		],
	},
	{
		title: 'Bull Market (Bullish)',
		content: [
			'A market where prices are rising or are perceived to be in an uptrend.',
		],
	},
	{
		title: 'Bunker Fuel',
		content: ['A heavier residual fuel oil used in a shop’s boilers.'],
	},
	{
		title: 'Butane (C4H10)',
		content: [
			'A normally gaseous straight-chain or branch-chain hydrocarbon extracted from natural gas or refinery gas streams. It includes normal butane and refinery-grade butane and is designated in ASTM Specification D1835 and Gas Processors Association Specifications for commercial butane. Butane is a key ingredient in motor fuel, but Reid Vapor Pressure restrictions make it less suitable for spring- and summer-specification gasoline.',
		],
	},
	{
		title: 'Butylenes (C4H8)',
		content: ['An olefinic hydrocarbon recovered from refinery processes.'],
	},
	{
		title: 'Buy-Out Costs (Buy-Down Costs)',
		content: [
			'Payments made by pipelines to producers to extinguish (buy-out) outstanding take-or-pay liabilities under existing contracts, or to reform (buy-down) the contracts.',
		],
	},
	{
		title: 'Buyer’s Right of First Refusal',
		content: [
			'In negotiating situations where the seller of gas has the right to solicit third-party bids for his gas, a right of first refusal provision gives the buyer of the gas the option of meeting the third party bid price and continuing the contract on such terms.',
		],
	},
	{
		title: 'By-Pass',
		content: [
			'An auxiliary piping arrangement, generally to carry gas around specific equipment or an integral section of a piping system. A by-pass is usually installed to permit passage through the line while adjustments or repairs are made on the section which is by-passed. Also used to describe the circumvention of a local distribution company’s distribution system to supply gas to a specific customer.',
		],
	},
	{
		title: 'C-Store',
		content: [
			'Short for convenience store, but also applying to retail gasoline outlets which sell convenience goods such as milk, cigarettes, soft drinks and bread.',
		],
	},
	{
		title: 'Call Option',
		content: [
			'Also referred to simply as a “call.” Refers to an option that gives the buyer the right but not the obligation to buy a futures contract at a specific strike price.',
		],
	},
	{
		title: 'Cap',
		content: [
			'Risk management program which, usually in exchange for an up front premium, offers a price ceiling for various size purchases of fuel. Caps are most commonly offered by suppliers who utilize petroleum futures options.',
		],
	},
	{
		title: 'Cap-and-Trade Program (California)',
		content: [
			'The California Cap-and-Trade Program, effective Jan. 1, 2012, is designed to reduce greenhouse gas (GHG) emissions from covered entities by setting a firm cap on statewide GHG emissions while employing market mechanisms to achieve the emission-reduction goals. A statewide cap for GHG emissions from entities, which is measured in metric tons of carbon dioxide equivalent (MTCO2e), commenced on Jan. 1, 2013, declines over time, achieving GHG emission reductions throughout the program’s duration. Each covered entity is required to surrender one compliance instrument (allowance or offset credit) for each ton of GHG emissions they emit.',
		],
	},
	{
		title: 'Captive Refinery Oxygenate Plants',
		content: [
			'Oxygenate production facilities located within or adjacent to a refinery complex.',
		],
	},
	{
		title: 'CARB Diesel',
		content: [
			'Term which refers to the diesel standard mandated for sale by the California Air Resources Board. It includes tough standards for sulfur and for very low aromatics.',
		],
	},
	{
		title: 'Carbon Allowance',
		content: [
			'A tradable cap-and-trade compliance instrument, acquired via auction or in the secondary market place, permitting entities covered under the California Cap-and-Trade Program regulations to emit one metric ton of a carbon dioxide equivalent greenhouse gas emission.',
		],
	},
	{
		title: 'Carbon Intensity (CI)',
		content: [
			'The amount of carbon by weight emitted per unit of energy consumed. A common measure of carbon intensity is weight of carbon per British thermal unit (Btu) of energy. When there is only one fossil fuel under consideration, the carbon intensity and the emissions coefficient are identical. When there are several fuels, carbon intensity is based on their combined emissions coefficients weighted by their energy consumption levels.',
		],
	},
	{
		title: 'Carload',
		content: ['Shipment of freight required to fill a railcar.'],
	},
	{
		title: 'Carrying Charge',
		content: [
			'The aggregate cost of storing a particular commodity, including, but not limited to, storage fees, cost of money, insurance, etc. Heating oil futures contracts often reflect carrying charges in the fall, leading forward months to trade at a premium to near-term positions.',
		],
	},
	{
		title: 'Cash Market (Also Spot Market)',
		content: [
			'High volume (25,000 to 300,000 bbl) contractual agreements between oil companies dictating delivery of petroleum products or crude oil in the near future for an established sales price. Since this market reacts quickly, and is an alternative to wholesale sales, it provides a good indication of the direction of wholesale price trends.',
		],
	},
	{
		title: 'Catalytic Cracking',
		content: [
			'The refining process of breaking via heat and pressure down the larger, heavier and more complex hydrocarbon molecules into simpler and lighter molecules, primarily gasoline. Catalytic cracking is accomplished by the use of a catalytic agent and is an effective process for increasing the yield of gasoline from crude oil.',
		],
	},
	{
		title: 'Catalytic Hydrocracking',
		content: [
			'A refining process that uses hydrogen and catalysts with relatively low temperatures and high pressures for converting middle boiling or residual material to high-octane gasoline, reformer charge stock, jet fuel, and/or high grade fuel oil. The process uses one or more catalysts, depending upon product output, and can handle high sulfur feedstocks without prior desulfurization.',
		],
	},
	{
		title: 'Catalytic Hydrotreating',
		content: [
			'A refining process for treating petroleum fractions from atmospheric or vacuum distillation units (e.g., naphthas, middle distillates, reformer feeds, residual fuel oil, and heavy gas oil) and other petroleum (e.g., cat cracked naphtha, coker naphtha, gas oil, etc.) in the presence of catalysts and substantial quantities of hydrogen. Hydrotreating includes desulfurization, removal of substances (e.g., nitrogen compounds) that deactivate catalysts, conversion of olefins to paraffins to reduce gum formation in gasoline, and other processes to upgrade the quality of the fractions.',
		],
	},
	{
		title: 'Catalytic Reforming',
		content: [
			'- A refining process using controlled heat and pressure with catalysts to rearrange certain hydrocarbon molecules, thereby converting paraffinic and naphthenic type hydrocarbons (e.g., low-octane gasoline boiling range fractions) into petrochemical feedstocks and higher octane stocks suitable for blending into finished gasoline. Catalytic reforming is reported in two categories.',
			'They are:',
			'● Low Pressure: A processing unit operating at less than 225 pounds per square inch gauge (PSIG) measured at the outlet separator.',
			'● High Pressure: A processing unit operating at either equal to or greater than 225 pounds per square inch gauge (PSIG) measured at the outlet separator.',
		],
	},
	{
		title: 'CBOB (Conventional Blendstock for Oxygenate Blending)',
		content: [
			'Conventional gasoline blendstock intended for blending with oxygenates downstream of the refinery where it was produced. CBOB must become conventional gasoline after blending with oxygenates. Motor gasoline blending components that require blending other than with oxygenates to become finished conventional gasoline are reported as All Other Motor Gasoline Blending Components. CBOB is the hydrocarbon building block most often used in the manufacture of E10 (90% CBOB and 10% ethanol) fuel. It is differentiated from reformulated blendstock for oxygenate blending (RBOB) which, when 10% ethanol is added, becomes a finished reformulated gasoline, or RFG.',
		],
	},
	{
		title: 'Cetane',
		content: [
			'A measure of the ignition quality of a diesel fuel. Regular diesel generally has a cetane number of 40-45, while most premium cetanes have numbers between 45-50.',
		],
	},
	{
		title: 'CAPEX',
		content: ['Capital expenditures.'],
	},
	{
		title: 'Carbon capture and storage (CCS)',
		content: [
			'Process by which carbon dioxide emissions are captured and removed from the atmosphere and then stored, normally via injection into a secure underground geological formation.',
		],
	},
	{
		title: 'Carbon dioxide equivalents (CO2e)',
		content: [
			'The quantity that describes, for a given mixture and amount of greenhouse gas, the amount of CO2 that would have the same global warming potential (GWP) when measured over a specified timescale (generally 100 years).',
		],
	},
	{
		title: 'Carbon intensity',
		content: [
			'The quantity of greenhouse gas emissions associated with producing an intermediate or final product. For the oil and gas industry, carbon intensity is commonly expressed in units of Tonnes CO2e per product volume (e.g. Tonnes CO2e/bbl or Tonnes CO2e/MCF).',
		],
	},
	{
		title: 'Carbon sequestration',
		content: [
			'The fixation of atmospheric carbon dioxide in a carbon sink through biological or physical processes.',
		],
	},
	{
		title: 'Carbon sink',
		content: [
			'A reservoir that absorbs or takes up released carbon from another part of the carbon cycle. The four sinks, which are regions of the Earth within which carbon behaves in a systematic manner, are the atmosphere, terrestrial biosphere (usually including freshwater systems), oceans and sediments (including fossil fuels).',
		],
	},
	{
		title: 'Casing',
		content: [
			'Thick walled steel pipe placed in wells to isolate formation fluids (such as fresh water) and to prevent borehole collapse.',
		],
	},
	{
		title: 'Coal bed methane (CBM)',
		content: ['Natural gas extracted from coal beds.'],
	},
	{
		title: 'Completion',
		content: [
			'The process of making a well ready to produce natural gas or oil. Completion involves installing permanent equipment, such as a wellhead, and often includes hydraulic fracturing.',
		],
	},
	{
		title: 'Compound annual growth rate (CAGR)',
		content: [
			'The average year-over-year growth rate of a metric over a specific period of time.',
		],
	},
	{
		title: 'Condensate',
		content: [
			'Mixture of hydrocarbons which are in a gaseous state under reservoir conditions and, when produced, become a liquid as the temperature and pressure is reduced.',
		],
	},
	{
		title: 'Conventional resources',
		content: [
			'Discrete accumulations of hydrocarbons contained in rocks with relatively high matrix permeability, which normally have relatively high recovery factors.',
		],
	},
	{
		title: 'Chain Marketer:',
		content: [
			'An independent marketer who retails gasoline through a chain of private branded gasoline or motor fuel outlets that are staffed with their own workers (company-ops).',
		],
	},
	{
		title: 'Charge Capacity:',
		content: [
			'The input (feed) capacity of the refinery processing facilities.',
		],
	},
	{
		title: 'Class I - VIII Trucks: Classification by Gross Vehicle Weight:',
		content: [
			'I: 6,000 lbs. or less',
			'II: 6,001-10,000 lbs.',
			'III: 10,001-14,000 lbs.',
			'IV: 14,001-16,000 lbs.',
			'V: 16,001-19,500 lbs.',
			'VI: 19,501-26,000 lbs.',
			'VII: 26,001-33,000 lbs.',
			'VIII: 33,001 lbs. or more',
		],
	},
	{
		title: 'Clearing Member',
		content: [
			'Term which applies to a member or a member firm of the NYMEX who has met the capital requirements to become a member of the clearing house and can accept and manage trades executed on the floor. All trades have to eventually go through a clearing member, and it is the member’s ultimate responsibility to guarantee performance.',
		],
	},
	{
		title: 'Close',
		content: [
			'The short period at the end of a futures trading session each day at which the closing price range is established.',
		],
	},
	{
		title: 'Coker',
		content: [
			'An oil refining unit in which heavy feed such as flasher bottoms, cycle oil from a fluid catalytic cracker, or thermal cracked gas oil is subjected to high temperatures. This causes the feed to crack, creating lights oils. Coke – solid, densely packed carbons – builds up in the reactors of the unit and periodically needs to be removed.',
		],
	},
	{
		title: 'Collar',
		content: [
			'Term which refers to a futures or derivatives program where the buyer locks in a price ceiling, but also a price floor. A trucking company which caps its autumn price at 60cts/gal but only shares in downward moves to a 50cts/gal price point has utilized a “collar” program from its supplier.',
		],
	},
	{
		title: 'Combination Vehicle',
		content: [
			'An equipment configuration which includes a separate power unit (tractor) and at least one trailer.',
		],
	},
	{
		title: 'Commercials',
		content: [
			'Oil companies, as opposed to speculators trading typically in a futures environment. Commercial entities typically have a stake in the supply chain as a physical producer of oil or a physical consumer of petroleum products.',
		],
	},
	{
		title: 'Commercial Trailer',
		content: [
			'A trailer used to handle freight in the transportation of goods for others, excludes house trailers, light farm trailers and car trailers.',
		],
	},
	{
		title: 'Commingling',
		content: [
			'Term which generally applies to the mixing of two petroleum products with similar specifications. Most branded gasoline firms require that their product not be commingled to preserve the integrity of the brand.',
		],
	},
	{
		title: 'Commission House',
		content: [
			'Term for the entities which buy and sell actual futures contracts for customers in exchange for a commission, also known in the trade as a futures commission merchant or FCM.',
		],
	},
	{
		title: 'Commodity Pool Operator (CPO)',
		content: [
			'Term which applies to a group which pools money to trade commodities, the commodities version of a mutual fund.',
		],
	},
	{
		title: 'Common Carrier',
		content: [
			'A pipeline or transport company which has government authority to move product for hire, operating like a public utility with standard rates for various shipments.',
		],
	},
	{
		title: 'Condensate',
		content: [
			'A naturally occurring gaseous hydrocarbon that liquefies when cooled to surface temperature. Condensate is considered to be a part of crude oil production. Precisely when API gravity is high enough to label a liquid as a condensate as opposed to a crude oil is a point of contention within the United States and abroad.',
		],
	},
	{
		title: 'Congested Market',
		content: [
			'A period of repetitious and limited price fluctuations within a tight trading range. A term often used to describe a “trendless” market.',
		],
	},
	{
		title: 'COFC (Container On (Rail) Flat Car)',
		content: ['A form of intermodal movement of freight.'],
	},
	{
		title: 'Contango',
		content: [
			'Term that describes a market which features higher prices for more distant delivery. If prompt crude is $18/bbl and delivery two months hence is $19/ bbl, the market is said to be in contango. Contango market typically suggests cheaper prices in the near-term because of oversupply or other signs of market weakness. Steep contango, or even supercontango, can encourage banks and large trading houses to store oil and sell it on a forward basis. The company would pocket the difference between carrying costs and the forward sale.',
		],
	},
	{
		title: 'Conversion Refining Capacity',
		content: [
			'The ability to perform those processes in gasoline production that add octane. This process is considered more complex than basic distillation.',
		],
	},
	{
		title: 'Correlation Coefficient',
		content: [
			'A statistical factor measuring how well any two markets (i.e. a cash market and a futures market) move in unison. A correlation coefficient of 1 would indicate a perfect 1-to-1 relationship.',
		],
	},
	{
		title: 'Cost-Plus',
		content: [
			'A pricing mechanism, commonly used by transportation firms. The buyer pays a specific cost over a benchmark, e.g. an OPIS rack average, with freight, taxes, and mark-up resulting in the final cost. These transactions are differentiated from retail prices.',
		],
	},
	{
		title: 'Cost of Carry',
		content: [
			'The cost to physically store crude or petroleum products, including storage fees, insurance, inspections and capital costs.',
		],
	},
	{
		title: 'Cover',
		content: ['To close out a long or short futures position.'],
	},
	{
		title: 'CPO (Commodity Pool Operator)',
		content: [
			'Term which applies to a concern which pools money to trade commodities – the commodities version of a mutual fund.',
		],
	},
	{
		title: 'Crack Spread',
		content: [
			'Term applied to the differential between what a typical refined products mix would yield, and the value of crude. The common crack spread features a per bbl reference derived of 66.6% unleaded gasoline and 33.4% No. 2 oil. The resulting average is compared to the WTI number for the resulting “crack spread.” Crack spreads of 3:2:1 use three parts gasoline, two parts of distillate to one part of crude.',
		],
	},
	{
		title: 'Crude Distillation Unit',
		content: [
			'An oil refinery unit that separates crude oil into different products according to their individual boiling point ranges. Distillation allows for the materials to be separated without being subjected to conditions that would cause cracking or decomposition.',
		],
	},
	{
		title: 'Crude Oil',
		content: [
			'The primary feedstock used to make gasoline, diesel, jet , residual fuel and other finished petroleum products. A mixture of hydrocarbons that exists in liquid phase in natural underground reservoirs and remains liquid at atmospheric pressure after passing through surface separating facilities. Depending upon the characteristics of the crude stream, it may also include:',
			'● Small amounts of hydrocarbons that exist in gaseous phase in natural underground reservoirs but are liquid at atmospheric pressure after being recovered from oil well (casinghead) gas in lease separators and are subsequently commingled with the crude stream without being separately measured.',
			'● Lease condensate recovered as a liquid from natural gas wells in lease or field separation facilities and later mixed into the crude stream is also included.',
			'● Small amounts of nonhydrocarbons produced from oil, such as sulfur and various metals.',
			'● Drip gases, and liquid hydrocarbons produced from tar sands, gilsonite, and oil shale.',
			'Liquids produced at natural gas processing plants are excluded. Crude oil is refined to produce a wide array of petroleum products, including heating oils, gasoline, diesel and jet fuels, lubricants, asphalt, ethane, propane, and butane, and many other products used for their energy or chemical content.',
		],
	},
	{
		title: 'Crude Oil, Refinery Receipts',
		content: [
			'Receipts of domestic and foreign crude oil at a refinery. Includes all crude oil in transit except crude oil in transit by pipeline. Foreign crude oil is reported as a receipt only after entry through customs. Crude oil of foreign origin held in bonded storage is excluded.',
		],
	},
	{
		title: 'Crude Oil Losses',
		content: [
			'Represents the volume of crude oil reported by petroleum refineries as being lost in their operations. These losses are due to spills, contamination, fires, etc. as opposed to refinery processing losses.',
		],
	},
	{
		title: 'Crude Oil Production',
		content: [
			'The volume of crude oil produced from oil reservoirs during given periods of time. The amount of such production for a given period is measured as volumes delivered from lease storage tanks (i.e., the point of custody transfer) to pipelines, trucks, or other media for transport to refineries or terminals with adjustments for (1) net differences between opening and closing lease inventories, and (2) basic sediment and water (BS&W).',
		],
	},
	{
		title: 'Crude Oil Qualities',
		content: [
			'Refers primarily to two properties of crude oil, the sulfur content and API gravity, which affect processing complexity and product characteristics.',
		],
	},
	{
		title: 'Crude Unit',
		content: [
			'The initial refining operation in which the basic cuts of fuel are distilled out of crude oil.',
		],
	},
	{
		title: 'Current Delivery Month',
		content: [
			'The futures contract date closest to expiration. Contracts are usually referred to by month (i.e. September Crude refers to crude contracts that are to be delivered in September).',
		],
	},
	{
		title: 'Daily Closing Average',
		content: [
			'An average of all rack suppliers (without those denoted as out-of-product), calculated for either gross or net. Calculated no later than 5:59 p.m. ET daily and published with OPIS rack displays.',
		],
	},
	{
		title: 'Daily Contract Average',
		content: [
			'An average of all rack suppliers (with the exception of those denoted as out of product), calculated either as gross or net average. Calculated at approximately 10:00 a.m. ET daily to allow time for our pricing specialists to do a validation check on the data. Daily contract average is frozen for 24 hours, generally from 10:00 AM to 10:00 AM for contract reconciliation purposes. Branded and unbranded averages are also available. ',
		],
	},
	{
		title: 'Day Order',
		content: [
			'Type of order to purchase or sell a futures contract where the order is valid for one day unless you specify otherwise.',
		],
	},
	{
		title: 'Day Trade',
		content: [
			'The purchase and sale of a futures or option contract during the same business day.',
		],
	},
	{
		title: 'Dealer Tankwagon (DTW)',
		content: [
			'The price that the dealer pays to its supplier, usually a jobber or refiner. Dealer prices are usually higher than rack prices because they include transportation costs. A tankwagon is a legacy term that applies to the actual vehicle that the supplier or jobber uses to transport product to the dealer, but in most cases, it has the same storage capacity as a transport truck.',
		],
	},
	{
		title: 'Deferred Futures',
		content: [
			'Contracts that will mature beyond the current delivery month. Also called distant or back month contracts.',
		],
	},
	{
		title: 'Degree Days',
		content: [
			'The number of degrees per day that the daily average temperature falls below 65 degrees Fahrenheit. The daily average temperature is the mean of the maximum and minimum temperature for a 24-hour period.',
		],
	},
	{
		title: 'Delayed Coking',
		content: [
			'A process by which heavier crude oil fractions can be thermally decomposed under conditions of elevated temperatures and pressure to produce a mixture of lighter oils and petroleum coke. The light oils can be processed further in other refinery units to meet product specifications. The coke can be used either as a fuel or in other applications such as the manufacturing of steel or aluminum.',
		],
	},
	{
		title: 'Delivered Spot',
		content: [
			'Detailed estimates of rack replacement costs using spot prices and including pipeline tariff costs, shrinkage fees, proprietary additive fees plus other miscellaneous costs.',
		],
	},
	{
		title: 'Delivery',
		content: [
			'The satisfaction of a futures contract by the tendering of the actual physical commodity.',
		],
	},
	{
		title: 'Department of Energy (DOE)',
		content: [
			'The U.S. federal government agency establishing programs and policies regarding national energy matter and includes the Energy Information Administration (EIA), a division that compiles data on petroleum supply and demand on a weekly and monthly basis.',
		],
	},
	{
		title: 'Derivatives',
		content: [
			'General term used to describe the class of futures-related instruments offered by oil companies, banks, large brokerage houses, etc. These programs are “derived” from general futures contracts, but often are tailor-made to individual market and company needs. Example: an oil company offering a price cap for No. 2 oil rack prices in Atlanta that’s tied to an OPIS average is offering a derivative. These can be “wet,” featuring actual physical purchases or sale, or “paper,” where only money exchanges hands. The term is often commonly used to include futures and options contracts, since they are “derivative” of the underlying commodities that they represent',
		],
	},
	{
		title: 'Desulfurization',
		content: [
			'The removal of sulfur, as from molten metals, petroleum oil, or flue gases. Petroleum desulfurization is a process that removes sulfur and its compounds from various streams during the refining process. Desulfurization processes include catalytic hydrotreating and other chemical/physical processes such as adsorption. Desulfurization processes vary based on the type of stream treated (e.g. naphtha, distillate, heavy gas oil, etc.) and the amount of sulfur removed (e.g. sulfur reduction to 10 ppm). See Catalytic Hydrotreating.',
		],
	},
	{
		title: 'Developed acreage',
		content: [
			'The number of acres that are allocated or assignable to productive wells or wells capable of production.',
		],
	},
	{
		title: 'Developed reserves',
		content: [
			'Reserves that can be expected to be recovered through existing wells with existing equipment and operating methods or in which the cost of the required equipment is relatively minor compared to the cost of a new well and, if extraction is by means other than a well, through installed equipment and infrastructure operational at the time of the reserves estimate.',
		],
	},
	{
		title: 'Development well',
		content: [
			'A well drilled within the proved area of an oil or gas reservoir to the depth of a stratigraphic horizon known to be productive.',
		],
	},
	{
		title: 'Diesel Exhaust Fluid (DEF)',
		content: [
			'A urea solution used in Selective Catalytic Reduction (SCR) to lower nitrogen oxide (NOx) concentration in the exhaust emissions from diesel engines.',
		],
	},
	{
		title: 'Disposition',
		content: [
			'The components of petroleum disposition are stock change, crude oil losses, refinery inputs, exports, and products supplied for domestic consumption. ',
		],
	},
	{
		title: 'Distillate',
		content: [
			'Includes No. 1 and No. 2 fuel oils, and No. 1 and No. 2 diesel fuels as well as some blends of overseas gasoil. These are light fuel oils for transportation and heating oil, and include railroad engine fuel and diesel for agricultural material. Lower sulfur distillates also represent the preferable feedstock for power generation, when utilities see natural gas curtailments or high natural gas prices.',
			'● No. 1 diesel fuel: A light distillate fuel oil that has distillation temperatures of 550 degrees F at the 90-percent point and meets the specifications defined in ASTM Specification D 975. It is used in high speed diesel engines generally operated under frequent speed and load changes, such as those in city buses and similar vehicles.',
			'● No. 1 fuel oil: A light distillate fuel oil that has distillation temperatures of 400 degrees F at the 10-percent recovery point and 550 degrees F at the 90-percent point and meets the specifications defined in ASTM Specification D 396. It is used primarily as fuel for outdoor stoves and portable outdoor heaters.',
			'● No. 2 diesel fuel: A fuel oil that has distillation temperatures of 500 degrees F at the 10-percent recovery point and 640 degrees at the 90-percent recovery point and meets the specifications defined in ASTM Specification D 975. It is used in high speed diesel engines generally operated under uniform speed and load conditions, such as those in railroad locomotives, trucks and automobiles. Most of the U.S. requires a 15-ppm sulfur or less standard in on-highway fuel.',
			'● Low-sulfur No. 2 diesel fuel: No. 2 diesel fuel that has a sulfur level less than 500 ppm used primarily in power engines used for off-highway use, typically at construction sites, etc.',
			'● High-sulfur No. 2 diesel fuel: No. 2 diesel fuel that has a sulfur content greater than 500 ppm and is used mainly for home heating oil in a few Northeastern U.S. markets.',
			'● No. 2 fuel oil (heating oil): A distillate fuel oil that has distillation temperatures of 400 degrees F at the 10-percent recovery point and 640 degrees F at the 90-percent recovery point and meets the specifications defined in ASTM Specification D 396.',
			'● It is used in atomizing type burners for domestic heating or for moderate capacity commercial/industrial burner units.',
			'● No. 4 fuel: A distillate fuel oil made by blending distillate fuel oil and residual fuel oil stocks. It conforms with ASTM Specification D 396 and is used extensively in industrial plants and in commercial burner installations that are not equipped with preheating facilities.',
			'● No. 2 ultra-low-sulfur: No. 2 Ultra-Low Sulfur has a sulfur content of less than 15 ppm and must be used to supply at least 80% of the nations on road diesel fuel sold at the retail level as of October 15, 2006. In addition to clear No. 2 low sulfur, OPIS also provides pricing for Red Dye, Premium, Low Emissions and Winter grades of Ultra low-sulfur diesel fuels. All of the OPIS Ultra Low-Sulfur diesel products are understood to include lubricity.',
			'● No. 2 high-sulfur: Clear high-sulfur No. 2 diesel is used as an off-road fuel for equipment such as farm machinery or home heating oil.',
			'● No. 1 low-sulfur: Clear low-sulfur fuel is commonly used for “blending” on-road fuels. Diesel is blended during winter months to create a diesel fuel that will not solidify or gel in colder temperatures.',
			'● No. 1 high-sulfur: Clear high sulfur is used for various off road agricultural and industrial purposes. Crop drying ovens is one example.',
			'● Kerosene: Kerosene has a lower freeze point, lower flash point and lower pour point.',
			'● Premium diesel: The higher cetane rating is what makes a regular diesel a premium diesel, along with some type of detergent package that serves to clean the engine as the fuel is burned. Cetane is to diesel what octane is to gasoline. Premium diesel typically has a minimum 45 cetane rating, whereas regular diesel is closer to a 38 to 40 cetane rating.',
			'● Red dye: Diesel fuel is dyed red to denote it is being used for tax-exempt purposes. by a tax-exempt entity (school boards, etc.). There is no difference in red-dyed product specifications. Red-dyed prices typically are 0.25 to 0.35cts higher than clear prices to recoup the charge for the dye and dying process.',
			'● Premium diesel : The higher cetane rating is what makes a regular diesel a premium diesel, although there can be an additional detergent package that serves to clean the engine as the fuel is burned. Cetane is to diesel what octane is to gasoline. Premium diesel typically has a minimum 45 cetane rating, whereas regular diesel is closer to a 38 to 40 cetane rating.',
			'● Winter diesel: During the winter months, on-road diesel fuels may be blended with other diesel fuels or chemical additives to produce a Winter diesel that will not begin to solidify or gel due to cold temperatures. OPIS also provides pricing for red dye, premium, and lubricity grades of winter diesel fuels.',
			'● Lubricity: Several states have mandated the use of a lubricity additive in several on road Low Sulfur diesel fuels. OPIS provides separate pricing displays for Low Sulfur and Low Sulfur with lubricity products. Diesel postings which may include lubricity are Low Sulfur, Red Dye, Winter and Premium diesel products. Since all Ultra-Low-Sulfur products must have a lubricity component, it is not necessary to maintain a separate lubricity product grouping within Ultra-Low-Sulfur products.',
			'● Low-emissions diesel: Beginning in October 2005, 110 counties East/Central Texas required the use of Low Emissions Diesel or LED in both on-road vehicles and in non-road agricultural and construction equipment. LED diesel must contain less than 10% by volume of aromatic hydrocarbons and must have a cetane number of 48 or greater.',
			'● Biodiesel: Made from renewable resources like soybeans and other natural fats and oils. It works in any diesel engine with few or no modifications. It can be used in pure form (B100) or blended with petroleum diesel at any level. Some states are now mandating the use of biodiesel.',
		],
	},
	{
		title: 'Distillation',
		content: [
			'The most basic refining operation that heats the crude oil and condenses the cuts in a fractionating column in order to separate the various petroleum products for further processing. ',
		],
	},
	{
		title: 'Downstream',
		content: [
			'Term applying to functions or facilities closer to the end-user. Refining, marketing and transportation are generally downstream processes in the oil patch while exploration and production are upstream. However, the term also applies to any function or facility below the point of reference: retailing is downstream of terminaling.',
		],
	},
	{
		title: 'Directional drilling',
		content: [
			'The application of special tools and techniques to drill a wellbore at a predetermined angle. Horizontal drilling is a form of directional drilling where the wellbore is ultimately drilled at +/- 90 degrees to the vertical direction.',
		],
	},
	{
		title: 'Drilling rig',
		content: ['The machine used to drill a wellbore.'],
	},
	{
		title: 'Dry gas',
		content: [
			'Dry gas is almost pure methane and occurs in the absence of liquid hydrocarbons or by processing natural gas to remove liquid hydrocarbons and impurities.',
		],
	},
	{
		title: 'Dry hole',
		content: [
			'A well incapable of economically producing saleable hydrocarbons in sufficient quantities to justify commercial exploitation.',
		],
	},
	{
		title: 'Dual trading',
		content: [
			'The practice by which a floor broker can trade for both his own account and execute orders for off-the-floor customers. Some contend that dual trading leads to the illegal practice of front-running, where unscrupulous individuals can trade for their account ahead of a large order from another customer.',
		],
	},
	{
		title: 'Dubai',
		content: [
			'The most widely traded Middle East spot market crude, produced in the United Arab Emirates.',
		],
	},
	{
		title: 'Electronic Trading',
		content: [
			'A futures trading system that automatically matches buyers and sellers through a computerized system, as opposed to the current open outcry system.',
		],
	},
	{
		title: 'End User',
		content: [
			'The ultimate consumer of petroleum products, most commonly used in connection with large industrial or utility consumers.',
		],
	},
	{
		title: 'Ending Stocks',
		content: [
			'Primary stocks of crude oil and petroleum products held in storage as of 12 midnight on the last day of the month. Primary stocks include crude oil or petroleum products held in storage at (or in) leases, refineries, natural gas processing plants, pipelines, tank farms, and bulk terminals that can store at least 50,000 barrels of petroleum products or that can receive petroleum products by tanker, barge, or pipeline. Crude oil that is in-transit by water from Alaska, or that is stored on Federal leases or in the Strategic Petroleum Reserve is included. Primary Stocks exclude stocks of foreign origin that are held in bonded warehouse storage.',
		],
	},
	{
		title: 'Energy Information Administration (EIA)',
		content: [
			'A division of the Department of Energy that compiles data on petroleum supply and demand on a weekly and monthly basis. These figures are not as timely as API statistics, but are considered more accurate.',
		],
	},
	{
		title: 'ETBE (ethyl tertiary butyl ether) (CH3)3COC2H5',
		content: [
			'An oxygenate blend stock formed by the catalytic etherfication of isobutylene with ethanol.',
		],
	},
	{
		title: 'Ethane (C2H6)',
		content: [
			'A normally gaseous straight-chain hydrocarbon. It is a colorless paraffinic gas that boils at a temperature of -127.48 degrees Fahrenheit. It is extracted from natural gas and refinery gas streams.',
		],
	},
	{
		title: 'Ethanol',
		content: [
			'An alcohol which is most often derived from corn. Ethanol is designed to be blended with gasoline to produce a cleaner burning fuel, and is an accepted oxygenate component for the oxygenated seasons mandated by the EPA.',
		],
	},
	{
		title: 'Ether',
		content: [
			'A generic term applied to a group of organic chemical compounds composed of carbon, hydrogen, and oxygen, characterized by an oxygen atom attached to two carbon atoms (e.g., methyl tertiary butyl ether).',
		],
	},
	{
		title: 'Ethylene (C2H4)',
		content: [
			'An olefinic hydrocarbon recovered from refinery processes or petrochemical processes. Ethylene is used as a petrochemical feedstock for numerous chemical applications and the production of consumer goods.',
		],
	},
	{
		title: 'Exchange Of Futures For Physicals (EFP)',
		content: [
			'Another means of making delivery in the futures market. EFP’s would allow for a delivery of physical product that doesn’t necessarily conform to NYMEX specifications (delivery at say, Baltimore). Terms can vary across a broad spectrum including location, time, and product specifications.',
		],
	},
	{
		title: 'Exports',
		content: [
			'Shipments of crude oil and petroleum products from the 50 States and the District of Columbia to foreign countries, Puerto Rico, the Virgin Islands, and other U.S. possessions and territories.',
		],
	},
	{
		title: 'E&P',
		content: ['Exploration and Production.'],
	},
	{
		title: 'Economically producible',
		content: [
			'A resource that generates revenue that exceeds, or is reasonably expected to exceed, the costs of the operation.',
		],
	},
	{
		title: 'Enhanced oil recovery (EOR)',
		content: [
			'One or more of a variety of processes that seek to improve recovery of hydrocarbon from a reservoir after the primary production phase.',
		],
	},
	{
		title: 'Environmental assessment',
		content: [
			'A study that can be required to assess the potential direct, indirect and cumulative environmental impacts of a project.',
		],
	},
	{
		title: 'Estimated ultimate recovery (EUR)',
		content: [
			'The sum of reserves remaining as of a given date and cumulative production as of that date.',
		],
	},
	{
		title: 'Exploratory well',
		content: [
			'A well drilled to find a new field or to find a new reservoir in a field previously found to be productive of oil or gas in another reservoir.',
		],
	},
	{
		title: 'Farm-in',
		content: [
			'The acquisition of part or all of an oil, natural gas or mineral interest from a third party',
		],
	},
	{
		title: 'Farm-out',
		content: [
			'The assignment of part or all of an oil, natural gas or mineral interest to a third party.',
		],
	},
	{
		title: 'FEED',
		content: [
			'Front-end engineering and design – part of a project’s life cycle.',
		],
	},
	{
		title: 'Feedstock',
		content: [
			'Any of the raw or semi finished materials which move to the various units of a refinery or petrochemical plant. Crude is a feedstock, but the term is mainly used to describe raw materials after the distillation process which in turn go on to more sophisticated units at the refinery. VGO, catfeed, naphtha, condensate and straight run residual fuel are commonly referred to as feedstocks.',
		],
	},
	{
		title: 'Field Production',
		content: [
			'Represents crude oil production on leases, natural gas liquids production at natural gas processing plants, new supply of other hydrocarbons/ oxygenates and motor gasoline blending components, and fuel ethanol blended into finished motor gasoline.',
		],
	},
	{
		title: 'Flexicoking:',
		content: [
			'A thermal cracking process which converts heavy hydrocarbons such as crude oil, tar sands bitumen, and distillation residues into light hydrocarbons. Feedstocks can be any pumpable hydrocarbons including those containing high concentrations of sulfur and metals.',
		],
	},
	{
		title: 'Floor Broker:',
		content: [
			'An exchange member who executes orders for futures contracts in the trading pit.',
		],
	},
	{
		title: 'Floor Trader',
		content: [
			'Trader in a futures pit that executes trades solely for his own account.',
		],
	},
	{
		title: 'Fluid Catalytic Cracker (FCC)',
		content: [
			'An oil refining unit in which a catalyst combines with a vacuum gas oil range feedstock at high temperatures to cause a reaction. This is the most popular design for catalytic cracking in a refinery, and it produces mostly gasoline and some distillate products.',
		],
	},
	{
		title: 'Fluid Coking:',
		content: [
			'A thermal cracking process utilizing the fluidized-solids technique to remove carbon (coke) for continuous conversion of heavy, low-grade oils into lighter products.',
		],
	},
	{
		title: 'FOB',
		content: [
			'Terms of a transaction where the seller agrees to make the product available within an agreed-upon time period at a given location. Any subsequent costs are the responsibility of the buyer.',
		],
	},
	{
		title: 'Force Majeure',
		content: [
			'The legal cancellation of a delivery obligation due to the occurrence of natural acts beyond the direct control of the seller (i.e., operating problems with tankers or refineries or weather disruptions). ',
		],
	},
	{
		title: 'Forward Market',
		content: [
			'Cash market (non-exchange) commitment to delivery of petroleum products or crude at a set price for future delivery (i.e., a fixed price contract).',
		],
	},
	{
		title: 'Fractionation Plant',
		content: [
			'A processing plant that separates hydrocarbon mixtures based on the vapor pressures of its component molecules, either by adding heat (distillation) or removing heat (condensation). Products such as propane, butane, and ethane are produced in this process.',
		],
	},
	{
		title: 'Fractions',
		content: [
			'The different cuts of petroleum products that come off a distillation column contingent on their volatility or boiling range. Fractions are essentially crude cut points at different boiling ranges that produce the various finished products.',
		],
	},
	{
		title: 'Fresh Feed Input',
		content: [
			'Represents input of material (crude oil, unfinished oils, natural gas liquids, other hydrocarbons and oxygenates or finished products) to processing units at a refinery that is being processed (input) into a particular unit for the first time.',
			'Examples:',
			'● Unfinished oils coming out of a crude oil distillation unit which are input into a catalytic cracking unit are considered fresh feed to the catalytic cracking unit.',
			'● Unfinished oils coming out of a catalytic cracking unit being looped back into the same catalytic cracking unit to be reprocessed are not considered fresh feed.',
		],
	},
	{
		title: 'Field',
		content: [
			'An area consisting of a single hydrocarbon reservoir or multiple geologically related reservoirs all grouped on or related to the same individual geological structure or stratigraphic condition.',
		],
	},
	{
		title: 'Flaring',
		content: [
			'The burning of natural gas for safety reasons or when there is no way to transport the gas to market or use the gas for other beneficial purposes (such as EOR or reservoir pressure maintenance). The practice of flaring is being steadily reduced as pipelines are completed and in response to environmental concerns.',
		],
	},
	{
		title: 'Formation',
		content: [
			'A rock layer which has distinct characteristics (e.g. rock type, geologic age).',
		],
	},
	{
		title: 'Fossil fuel',
		content: [
			'A fuel source (such as oil, condensate, natural gas, natural gas liquids or coal) formed in the earth from plant or animal remains.',
		],
	},
	{
		title: 'Floating production, storage and offloading (FPSO)',
		content: [
			'Provides alternative to pipeline to store oil production and load vessels for movement to markets.',
		],
	},
	{
		title: 'Fugitive Emissions',
		content: [
			'Emissions of gases or vapors from pressurized equipment, including pipelines, due to leakage, unintended or irregular releases of gases.',
		],
	},
	{
		title: 'Front-Running',
		content: [
			'Illegal practice where a floor broker executes an order for his own account before executing an order for a customer, with the intent of getting ahead of a market move precipitated by the customer’s order. A broker who went long 10 contracts of December crude just before he executed a buy order for 500 contracts would be “front- running.” The audit trail, which timestamps when orders are received, etc., is intended to make this practice difficult to get away with.',
		],
	},
	{
		title: 'Fuel Ethanol (C2H5OH)',
		content: [
			'An anhydrous denatured aliphatic alcohol intended for gasoline blending as described in Oxygenates definition.',
		],
	},
	{
		title: 'Fuels Solvent Deasphalting',
		content: [
			'A refining process for removing asphalt compounds from petroleum fractions, such as reduced crude oil. The recovered stream from this process is used to produce fuel products. Fundamentals: Pricing analysis based on supply and demand factors for any particular market.',
		],
	},
	{
		title: 'Fundamental Analysis',
		content: [
			'Analysis derived from actual supply and demand factors such as inventories, refinery operations, physical buying patterns, or disruptions in the supply and distribution chain. Contrasts with technical analysis.',
		],
	},
	{
		title: 'Fungible',
		content: [
			'Term which refers to the likeness or at least “interchangeability of a petroleum product.” Material shipped on a pipeline must be “fungible,” i.e., have a common set of specifications acceptable to various shippers, and the same holds true for futures contracts. The less fungible the product, the less likely it is to succeed in the futures arena and the more problem it is likely to create in the distribution process. Various elements of the Clean Air Act have made several petroleum products less fungible.',
		],
	},
	{
		title: 'Furnace Oil',
		content: [
			'Canadian term used to describe high-sulfur No. 2 oil. So furnace oil in Canada is the equivalent of our high-sulfur, off-road, home heating oil.',
		],
	},
	{
		title: 'Futures',
		content: [
			'A standardized contract for the future purchase or sale of a commodity on a formalized exchange.',
		],
	},
	{
		title: 'Futures Margin',
		content: [
			'A deposit required of futures participants that guarantees assurance of performance. Funds are on hand to assure that the buyer or seller makes good on any losses that might accrue on his position. Margin deposits are a sort of futures performance bond.',
		],
	},
	{
		title: 'Gallon',
		content: [
			'Measurement of volume in the oil industry (42 gallons = 1 barrel).',
		],
	},
	{
		title: 'Gasoil',
		content: [
			'Commonly, the European term used for diesel fuel and heating oil.',
		],
	},
	{
		title: 'Gasohol',
		content: [
			'A blend of finished motor gasoline containing alcohol (generally ethanol but sometimes methanol) at a concentration of 10% or less by volume. Data on gasohol that has at least 2.7% oxygen, by weight, and is intended for sale inside carbon monoxide nonattainment areas are included in data on oxygenated gasoline. See Oxygenates.',
		],
	},
	{
		title: 'Gasoline',
		content: [
			'A complex mixture of relatively volatile hydrocarbons with or without small quantities of additives, blended to form a fuel suitable for use in spark-ignition engines. Motor gasoline, as defined in ASTM Specification D 4814, is characterized as having a boiling range of 122 to 158 degrees F at the 10 percent recovery point to 365-374 degrees F at the 90 percent recovery point.',
			'● Conventional gasoline: Finished motor gasoline not included in the oxygenated or reformulated gasoline categories. Note: This category excludes reformulated gasoline blendstock for oxygenate blending (RBOB) as well as other blendstock.',
			'● OPRG: “Oxygenated Fuels Program Reformulated Gasoline” is reformulated gasoline which is intended for use in an oxygenated fuels program control area.',
			'● Oxygenated gasoline (including gasohol): Oxygenated gasoline includes all finished motor gasoline, other than reformulated gasoline, having oxygen content of 2.0% or higher by weight. Gasohol containing a minimum 5.7% ethanol by volume is included in oxygenated gasoline. Oxygenated gasoline was reported as a separate product from January 1993 until December 2003 inclusive. Beginning with monthly data for January 2004, oxygenated gasoline is included in conventional gasoline. Historical data for oxygenated gasoline excluded Federal Oxygenated Program Reformulated Gasoline (OPRG). Historical oxygenated gasoline data also excluded other reformulated gasoline with a seasonal oxygen requirement regardless of season.',
			'● Reformulated gasoline: Finished gasoline formulated for use in motor vehicles, the composition and properties of which meet the requirements of the reformulated gasoline regulations promulgated by the U.S. Environmental Protection Agency under Section 211(k) of the Clean Air Act. It includes gasoline produced to meet or exceed emissions performance and benzene content standards of federal-program reformulated gasoline even though the gasoline may not meet all of the composition requirements (e.g. oxygen content) of federal-program reformulated gasoline. Reformulated gasoline excludes Reformulated Blendstock for Oxygenate Blending (RBOB) and Gasoline Treated as Blendstock (GTAB). Historical reformulated gasoline statistics included Oxygenated Fuels Program Reformulated',
		],
	},
	{
		title: 'Gasoline (OPRG)',
		content: [
			'● Reformulated (blended with ether): Reformulated gasoline blended with an ether component at a terminal or refinery to raise the oxygen content.',
			'● Reformulated (blended with alcohol): Reformulated gasoline blended with an alcohol component (e.g. fuel ethanol) at a terminal or refinery to raise the oxygen content.',
			'● Reformulated (non-oxygenated): Reformulated gasoline without added ether or alcohol components.',
		],
	},
	{
		title: 'Gasoline Blending Components',
		content: [
			'Naphthas which will be used for blending or compounding into finished aviation or motor gasoline (e.g., straight-run gasoline, alkylate, reformate, benzene, toluene, and xylenes). Excludes oxygenates (alcohols, ethers), butane, and natural gasoline.',
		],
	},
	{
		title: 'Globex',
		content: [
			'A global automated trade execution system (see electronic trading) created by the Chicago Merc and Reuters. The New York Mercantile Exchange approved the implementation of this system to supplement pit trading after hours.',
		],
	},
	{
		title: 'Gross',
		content: ['Price not inclusive of prompt payment discounts.'],
	},
	{
		title: 'Gross Average',
		content: [
			'An average of all suppliers, calculated without the deduction of any pre-payment terms.',
		],
	},
	{
		title: 'Gross Domestic Product (GDP)',
		content: [
			'A measure of the money value of the goods and services becoming available to the nation from economic activity within the United States.',
		],
	},
	{
		title: 'Gross Input to Atmospheric Crude Oil Distillation Units',
		content: [
			'Total input to atmospheric crude oil distillation units. Includes all crude oil, lease condensate, natural gas plant liquids, unfinished oils, liquefied refinery gases, slop oils, and other liquid hydrocarbons produced from tar sands, gilsonite, and oil shale.',
		],
	},
	{
		title: 'Group 3 Spot Market',
		content: [
			'Spot market vernacular for a Midwest delivery. It specifically entails delivery of finished products along key pipelines serving the Midwest markets from the Gulf Coast through the Plains States of Oklahoma, Missouri, Kansas, Iowa, Nebraska, Minnesota, South Dakota and North Dakota. Group 3 is the oil refining and distribution system basically serving these markets.',
		],
	},
	{
		title: 'GTAB (gasoline treated as blendstock)',
		content: [
			'Non-certified Foreign Refinery gasoline classified by an importer as blendstock to be either blended or reclassified with respect to reformulated or conventional gasoline. GTAB is classified as either reformulated or conventional based on emissions performance and the intended end use.',
		],
	},
	{
		title: 'Gulf Coast Spot Market',
		content: [
			'Large volume transactions (from 25,000 barrels to full tankers of petroleum products) bought or sold for a stipulated delivery in the near future.',
			'Although this market might entail several pipeline or waterborne transaction points in the Texas and Louisiana area, unless specified otherwise, it reflects the delivery of the product the same month at a Pasadena, Texas, origin on Colonial Pipeline. Gulf Coast barrels can also move into the Midwest via the TEPPPCO Enterprise Pipeline.',
		],
	},
	{
		title: 'Global-warming potential (GWP)',
		content: [
			'The relative measure of how much heat a greenhouse gas traps in the atmosphere. It compares the amount of heat trapped by a certain mass of the gas in question to the amount of heat trapped by a similar mass of carbon dioxide. GWP is calculated over a specific time interval, commonly 100 years. GWP is expressed as a multiple of that for carbon dioxide (whose GWP is standardized to 1).',
		],
	},
	{
		title: 'Greenhouse gas',
		content: [
			"Atmospheric gases that are transparent to solar (short-wave) radiation but opaque to long-wave (infrared) radiation, thus preventing long-wave radiant energy from leaving Earth's atmosphere. The net effect of these gases is a trapping of absorbed radiation and a tendency to warm the planet's surface. The greenhouse gases most relevant to the oil and gas industry are carbon dioxide, methane and nitrous oxide.",
		],
	},
	{
		title: 'Heating Oil',
		content: [
			'A distillate used for home or commercial heating. Widely used as a synonym for No. 2 home heating oil.',
		],
	},
	{
		title: 'Heavy Gasoil',
		content: [
			'Petroleum distillates with an approximate boiling range from 651 degrees Fahrenheit to 1,000 degrees Fahrenheit.',
		],
	},
	{
		title: 'Hedger',
		content: [
			'Oil industry participant who takes a futures, options, or derivatives position opposite that of a position held in the cash or contract market. A refiner who sells 500 forward gasoline contracts against his future production is hedging. A hedger is looking to reduce risk in exchange for a guaranteed margin, but he may forego larger profits in reducing his exposure.',
		],
	},
	{
		title: 'Hedging',
		content: [
			'The initiation of an opposite futures position to protect a cash market position from an adverse price movement. Hedging is essentially the act of managing price risks in the physical markets using oil futures pricing instruments. ',
		],
	},
	{
		title: 'Historical Volatility',
		content: [
			'The annualized standard deviation of percent variation in futures prices over a specific period of time and indicator of past volatility in the marketplace.',
		],
	},
	{
		title: 'Hydrocracker',
		content: [
			'An oil refining process in which light or heavy gas oils or residue hydrocarbons are mixed with hydrogen under conditions of high temperature and pressure, in the presence of a catalyst, yielding light oils.',
		],
	},
	{
		title: 'Hydrocracking',
		content: [
			'A refining process for converting middle distillates to high octane gasoline, jet fuel, or high grade diesel through the introduction of a hydrogen catalysts under very high pressure.',
		],
	},
	{
		title: 'Hydrogen',
		content: [
			'The lightest of all gases, occurring chiefly in combination with oxygen in water and exists also in acids, bases, alcohols, petroleum, and other hydrocarbons.',
		],
	},
	{
		title: 'Hydrotreate',
		content: [
			'A refining unit whereby processed material from the crude units are treated in the presence of catalysts and hydrogen, often to remove sulfur and other unwanted substances. The hydrotreater is often the critical unit for producing jet fuel and low-sulfur diesel.',
		],
	},
	{
		title: 'Heavy oil',
		content: [
			'Crude oil with an API gravity less than 20°. Heavy oil generally does not flow easily due to its elevated viscosity',
		],
	},
	{
		title: 'Horizontal drilling',
		content: [
			'A drilling technique whereby a well is progressively turned from vertical to horizontal so as to allow for greater exposure to an oil or natural gas reservoir. Horizontal laterals can be more than a mile long. In general, longer exposure lengths allow for more oil and natural gas to be recovered from a well and often can reduce the number of wells required to develop a field, thereby minimizing surface disturbance. Horizontal drilling technology has been extensively used since the 1980s and is appropriate for many, but not all, developments.',
		],
	},
	{
		title: 'Hydraulic fracturing',
		content: [
			'Hydraulic fracturing (also referred to as frac’ing or fracking) is an essential completion technique in use since the 1940s that facilitates production of oil and natural gas trapped in low-permeability reservoir rocks. The process involves pumping fluid at high pressure into the target formation, thereby creating small fractures in the rock that enable hydrocarbons to flow to the wellbore. View our hydraulic fracturing overview fact sheet for more details.',
		],
	},
	{
		title: 'Hydraulic fracturing fluids',
		content: [
			'Mixture of water and proppant along with minor amounts of chemical additives used to hydraulically fracture low permeability formations. Water and sand typically comprise up to 99.5 percent of the mixture. View our hydraulic fracturing fluid fact sheet for more details.',
		],
	},
	{
		title: 'Hydrocarbons',
		content: [
			'An organic compound containing only carbon and hydrogen and often occurring in nature as petroleum, natural gas, coal and bitumens or in refined products such as gasoline and jet fuel.',
		],
	},
	{
		title: 'Idle Capacity',
		content: [
			'The component of operable capacity that is not in operation and not under active repair, but capable of being placed in operation within 30 days and capacity not in operation but under active repair that can be completed within 90 days.',
		],
	},
	{
		title: 'Implied Volatility',
		content: [
			'A measurement of the market’s expected price range and variation for the underlying commodity futures based on market traded options premiums. Differs from historical volatility that lists annualized standard deviation of percent changes in futures prices over a specific period.',
		],
	},
	{
		title: 'Improved oil recovery (IOR)',
		content: [
			'Term used to describe methods employed to improve the flow of hydrocarbons from the reservoir to the wellbore or to recover more oil or natural gas. Enhanced oil recovery (EOR) would be one form of IOR.',
		],
	},
	{
		title: 'Infill wells',
		content: [
			'Wells drilled into the same reservoir as known producing wells so that oil or natural gas does not have to travel as far through the formation, thereby helping to improve or accelerate recovery',
		],
	},
	{
		title: 'In-situ recovery',
		content: [
			'Techniques used to extract hydrocarbons from deposits of extra-heavy crude oil, bitumen or oil shale without removing the soil and other overburden materials.',
		],
	},
	{
		title: 'Imported Crude Oil Burned as Fuel',
		content: [
			'The amount of foreign crude oil burned as a fuel oil, usually as residual fuel oil, without being processed as such. Imported crude oil burned as fuel includes lease condensate and liquid hydrocarbons produced from tar sands, gilsonite, and oil shale.',
		],
	},
	{
		title: 'Imports',
		content: [
			'Receipts of crude oil and petroleum products into the 50 States and the District of Columbia from foreign countries, Puerto Rico, the Virgin Islands, and other U.S. possessions and territories.',
		],
	},
	{
		title: 'Initial Margin',
		content: [
			'Funds required to establish a new position. Exchanges set minimums depending on volatility, market conditions, etc. and the brokerage firm may set margins above these exchange minimums. Margins for a would-be speculator are much higher than for a bona fide hedger.',
		],
	},
	{
		title: 'Integrated Oil Company',
		content: [
			'A company involved in all aspects of the petroleum business from wellhead crude production to retail sales of refined petroleum products.',
		],
	},
	{
		title: 'Interface',
		content: [
			'A mixture of petroleum products occurring when batches of different products are shipped consecutively through a pipeline. Interface oil is re-refined into gasoline and diesel.',
		],
	},
	{
		title: 'Intermodal Transportation',
		content: [
			'Transportation movement involving more than one mode (e.g. rail/motor, motor/air, or rail/water).',
		],
	},
	{
		title: 'International Energy Agency (IEA)',
		content: [
			'An agency in Paris, France, which tracks energy statistics and information on an international level.',
		],
	},
	{
		title: 'Interstate Commerce Commission (ICC)',
		content: [
			'Former motor carrier regulating authority, eliminated by the ICC Termination Act of 1995 (see DOT).',
		],
	},
	{
		title: 'In the Money Option (calls)',
		content: [
			'Refers to an option where the futures price has exceeded the strike price on which it is based. An option to buy December heating oil at 60cts/ gal is “in the money” when Dec. heating oil futures move above 60cts/gal. A put option for 60cts/gal would be “in the money” if the futures price is under the 60cts/gal strike price.',
		],
	},
	{
		title: 'Intrinsic Value',
		content: [
			'The amount by which an options contract is in the money. A 60cts/gal call option would have 2cts/gal of “intrinsic value” if the underlying futures price were 62cts/gal. Introducing Broker (IB): A firm that solely solicits or accepts orders for the purchase or sale of futures contracts or options.',
		],
	},
	{
		title: 'Inverted Market (inversion)',
		content: [
			'See backwardation.',
			'International Petroleum Exchange (IPE):',
			'International Petroleum Exchange, based in London, is the European equivalent of the NYMEX. IPE operates an exchange which trades Brent and gasoil (heating oil) futures among other energy contracts.',
		],
	},
	{
		title: 'ISTEA',
		content: ['Intermodal Surface Transportation Efficiency Act of 1991.'],
	},
	{
		title: 'Isobutane (C4H10)',
		content: [
			'A normally gaseous branch-chain hydrocarbon. It is a colorless paraffinic gas that boils at a temperature of 10.9 degrees Fahrenheit. It is extracted from natural gas or refinery gas streams.',
		],
	},
	{
		title: 'Isobutylene (C4H8)',
		content: [
			'An olefinic hydrocarbon recovered from refinery processes or petrochemical processes.',
		],
	},
	{
		title: 'Isohexane (C6H14)',
		content: [
			'A saturated branch-chain hydrocarbon. It is a colorless liquid that boils at a temperature of 156.2 degrees Fahrenheit.',
		],
	},
	{
		title: 'Isomerization',
		content: [
			'A refining process which alters the fundamental arrangement of atoms in the molecule without adding or removing anything from the original material. Used to convert normal butane into isobutane (C4), an alkylation process feedstock, and normal pentane and hexane into isopentane (C5) and isohexane (C6), high-octane gasoline components.',
		],
	},
	{
		title: 'Jack-up rig',
		content: [
			'An offshore rig with retractable steel legs that are placed on the ocean floor to raise the rig above the water line.',
		],
	},
	{
		title: 'Joint operating agreement (JOA)',
		content: [
			'An agreement governing the rights and obligations of co-owners in a field or undeveloped acreage, which defines, amongst other things, how costs and revenues are to be shared among the parties and who is the operator.',
		],
	},
	{
		title: 'Jobber',
		content: [
			'Someone who purchases refined products at the wholesale level and then transfers or resells the product at the retail level. The retail level sale/transfer can occur at facilities owned by the jobber, independent dealers or commercial accounts, a term used to describe companies in the oil distribution chain that wholesale products.',
		],
	},
	{
		title: 'Kerosene',
		content: [
			'A light petroleum distillate that is used in space heaters, cook stoves, and water heaters and is suitable for use as a light source when burned in wick-fed lamps. Kerosene has a maximum distillation temperature of 400 degrees Fahrenheit at the 10-percent recovery point, a final boiling point of 572 degrees Fahrenheit, and a minimum flash point of 100 degrees Fahrenheit. Included are No. 1-K and No. 2-K, the two grades recognized by ASTM Specification D 3699 as well as all other grades of kerosene called range or stove oil, which have properties similar to those of No. 1 fuel oil. See Kerosene-Type Jet Fuel.',
		],
	},
	{
		title: 'Kilowatt (kW)',
		content: ['One thousand watts.'],
	},
	{
		title: 'Kilowatt demand',
		content: [
			'A measure of average load over a given period expressed in kilowatts. This measurement is used by utilities and wholesalers to determine a customer’s average requirement.',
		],
	},
	{
		title: 'Kilowatt-hour',
		content: [
			'• A quantitative measure of electric current flow equivalent to one thousand watts being used continuously for a period on one hour; the unit most commonly used to measure electrical energy, as opposed to kilowatt, which is simply a measure of available power.',
			'• Customer billings for all but the largest consumers are usually based in part or in total on the number of kilowatt-hours of electricity used. The standard unit of current flow used in physics is the joule, but since a joule is only equivalent to one watt-second, kilowatt-hour has become a much more convenient standard.',
			'• A kilowatt-hour of energy typically costs between two and 20 cents depending on where and when it is purchased and by whom. This much energy will operate a 40-watt lightbulb for a full day, a 19" colour television for about four hours, a personal computer for 2 and-a-half hours, an electric hairdryer for 30 to 60 minutes, an electric razor for 36 hours, a clothes dryer for 15 minutes, a microfurnace heater for 40 minutes, a clock radio for up to several days, a portable stereo for as long as a week, and a telephone answering machine for as long as a month.',
			'• The kilowatt-hour is the base unit for nearly all measurements of energy volume both inside and outside the energy industry, although other values are occasionally used.',
		],
	},
	{
		title: 'Kilowatt-hours per capita',
		content: [
			'A measurement of average per-person energy generation for a given region. The number of kilowatt-hours of energy produced, not the number consumed, is divided by the total population of the region to arrive at this figure.',
		],
	},
	{
		title: 'Kerosene-Type Jet Fuel',
		content: [
			'A kerosene-based product having a maximum distillation temperature of 400 degrees Fahrenheit at the 10-percent recovery point and a final maximum boiling point of 572 degrees Fahrenheit and meeting ASTM Specification D 1655 and Military Specifications MIL-T-5624P and MIL-T-83133D (Grades JP-5 and JP-8). It is used for commercial and military turbojet and turboprop aircraft engines.',
			'● Commercial: Kerosene-type jet fuel intended for use in commercial aircraft.',
			'● Military: Kerosene-type jet fuel intended for use in military aircraft.',
		],
	},
	{
		title: 'Kyoto Protocol',
		content: [
			'The Kyoto Protocol was agreed by all countries under the UN Framework Convention on Climate Change in Kyoto, Japan, in December 1997. The Protocol requires industrialised countries to meet differentiated greenhouse gas emissions reduction targets relative to 1990 levels during the period 2008-12. It has been ratified by 177 countries, including all industrialised countries, with the exception of the United States of America. The Protocol establishes the framework for international emissions trading as well as the Clean Development Mechanism which aims to incentivise clean investment in developing countries.',
		],
	},
	{
		title: 'Lease Condensate',
		content: [
			'A mixture consisting primarily of pentanes and heavier hydrocarbons which is recovered as a liquid from natural gas in lease separation facilities. This category excludes natural gas liquids, such as butane and propane, which are recovered at downstream natural gas processing plants or facilities. See Natural Gas Liquids.',
		],
	},
	{
		title: 'Light Gasoils',
		content: [
			'Liquid petroleum distillates heavier than naphtha, with an approximate boiling range from 401 degrees Fahrenheit to 650 degrees Fahrenheit.',
		],
	},
	{
		title: 'Last Trading Day',
		content: [
			'The final trading session on a futures contract. Any contracts left open at the end must be settled by delivery. On the NYMEX, this falls on the last business day of the month for products and the third business day prior to the 25th on crude.',
		],
	},
	{
		title: 'Lightering',
		content: [
			'The process of transferring oil cargo between vessels of largely different sizes is undertaken as many port facilities cannot accept ocean-faring tankers the size of oil transports.',
		],
	},
	{
		title: 'Limit Move',
		content: [
			'The maximum one-day price advance or decline permitted from the previous day’s settlement price. Not applicable to the current contract. The limit move is 2 cents on products and $1.00 on crude.',
		],
	},
	{
		title: 'Limit Order',
		content: [
			'An order to buy/sell a futures/ options contract with a price limit. If it’s a buy order, it can’t be executed higher than the limit listed (e.g. 70cts/gal). If it’s a sell order, it can’t be executed lower than the limit.',
		],
	},
	{
		title: 'Liquefied Petroleum Gases (LPG)',
		content: [
			'A group of hydrocarbon-based gases derived from crude oil refining or natural gas stream fractionation that are often liquified, through pressurization, for ease of transport. They include: ethane, propane, normal butane, isobutane and add natural gasoline. Uses of these fuels include: home heating, industrial, automotive fuel, petrochemical feedstocks and for drying purposes in farming.',
		],
	},
	{
		title: 'Liquefied Refinery Gases (LRG)',
		content: [
			'Liquefied petroleum gases fractionated from refinery or still gases. Through compression and/or refrigeration, they are retained in the liquid state. The reported categories are ethane/ethylene, propane/propylene, normal butane/butylenes, and isobutane/isobutylene. Excludes still gas.',
		],
	},
	{
		title: 'Locals',
		content: [
			'Term which describes the floor traders who provide liquidity for NYMEX traders. Locals often are floor brokers who trade for their own account. Locals operate in the various electronic formats on the NYMEX and typically trade large volumes and cash in profits or losses after small changes in price.',
		],
	},
	{
		title: 'Long',
		content: [
			'Having an outstanding position where one has bought a futures contract or a wet bbl. A speculative “long” would be hopeful of a market increase. A lot of “length” in the wet or futures market could be descriptive of a market where too many buyers are holding inventory.',
		],
	},
	{
		title: 'LP',
		content: [
			'A shorthand reference commonly applied to propane, or liquid propane, which is used as a home heating and cooking fuel, and as a petrochemical feedstock.',
		],
	},
	{
		title: 'Lubricants',
		content: [
			'Substances used to reduce friction between bearing surfaces or as process materials either incorporated into other materials used as processing aids in the manufacture of other products, or used as carriers of other materials. Petroleum lubricants may be produced either from distillates or residues. Lubricants include all grades of lubricating oils from spindle oil to cylinder oil and those used in greases.',
		],
	},
	{
		title: 'Lease',
		content: [
			'A legal document executed between a mineral owner and a company or individual that conveys the right to explore for and develop hydrocarbons and/or other products for a specified period of time over a given area.',
		],
	},
	{
		title: 'Life Cycle Analysis (LCA)',
		content: [
			'LCA is an analytical methodology used to comprehensively quantify and interpret the environmental flows to and from the environment (including air emissions, water effluents, solid waste and the consumption/ depletion of energy and other resources) over the life cycle of a product or process. LCAs should be performed in adherence to the International Organization for Standardization (ISO) 14040 series of standards.',
		],
	},
	{
		title: 'Liquefied natural gas (LNG)',
		content: [
			'Natural gas that has been converted to a liquid by refrigerating it to -260°F. Liquefying natural gas reduces the fuel’s volume by 600 times, enabling it to be shipped economically from distant producing areas to markets.',
		],
	},
	{
		title: 'Margin',
		content: [
			'The funds deposited by a buyer or seller of a futures contract that ensure performance of the contract.',
		],
	},
	{
		title: 'Margin Call',
		content: [
			'A demand for initial or variation margin from a commission house to a customer and/or from the clearing house to a clearing member.',
		],
	},
	{
		title: 'Market-On-Close (MOC)',
		content: [
			'An order to buy/sell a futures/options contract which won’t be executed until the close of trading that day. It will be executed at the best possible price within the closing minutes of the market.',
		],
	},
	{
		title: 'Merc',
		content: ['See New York Mercantile Exchange (NYMEX).'],
	},
	{
		title: 'Merchant Oxygenate Plants',
		content: [
			'Oxygenate production facilities that are not associated with a petroleum refinery. Production from these facilities is sold under contract or on the spot market to refiners or other gasoline blenders.',
		],
	},
	{
		title: 'Methanol (CH3OH)',
		content: [
			'A light, volatile alcohol intended for gasoline blending as described in Oxygenate definition.',
		],
	},
	{
		title: 'Methyl Tertiary Butyl Ether (MTBE)',
		content: [
			'An ether used in the blending of reformulated gasolines, affecting vapor pressure and octane level. Unlike ethanol, MTBE is fungible and will not separate out during shipment. There is no domestic market for MTBE, so any production is exported.',
		],
	},
	{
		title: 'Midcon (Midcontinent)',
		content: [
			'A spot market designation for product delivered in regions supplied by the Group 3 and Chicago spot markets.',
		],
	},
	{
		title: 'Middle East Economic Survey (MEES)',
		content: [
			'An influential Nicosia-based newsletter which is regarded as particularly close to Arabian Gulf producer politics and intentions.',
		],
	},
	{
		title: 'MBBL',
		content: [
			'One thousand barrels of crude oil, bitumen, condensate or natural gas liquids.',
		],
	},
	{
		title: 'MBD',
		content: ['One thousand barrels per day.'],
	},
	{
		title: 'MBOE',
		content: ['One thousand barrels of oil equivalent.'],
	},
	{
		title: 'MCF',
		content: [
			'One thousand standard cubic feet of natural gas. In the United States, standard conditions are defined as gas at 14.7 psia and 60o F.',
		],
	},
	{
		title: 'MMBBL',
		content: [
			'One million barrels of crude oil, bitumen, condensate or natural gas liquids.',
		],
	},
	{
		title: 'MMBOE',
		content: ['One million barrels of oil equivalent.'],
	},
	{
		title: 'MMBTU',
		content: ['One million British thermal units.'],
	},
	{
		title: 'MMCF',
		content: [
			'One million standard cubic feet of natural gas. In the United States, standard conditions are defined as gas at 14.7 psia and 60o F.',
		],
	},
	{
		title: 'MTPA',
		content: ['Millions of tonnes per annum.'],
	},
	{
		title: 'Middle Distillates',
		content: [
			'A general classification of refined petroleum products that includes distillate fuel oil and kerosene, over-the-road diesel, and home heating oil.',
		],
	},
	{
		title: 'Miscellaneous Products',
		content: [
			'Includes all finished products not classified elsewhere (e.g., petrolatum, lube refining byproducts (aromatic extracts and tars), absorption oils, ram-jet fuel, petroleum rocket fuels, synthetic natural gas feedstocks, and specialty oils).',
			'Note: Beginning with January 2004 data, naphtha-type jet fuel is included in Miscellaneous Products.',
		],
	},
	{
		title: 'Modal Share',
		content: [
			'The percentage of total freight moved by a particular type of transportation.',
			'Motor Gasoline Blending:',
			'Mechanical mixing of motor gasoline blending components, and oxygenates when required, to produce finished motor gasoline. Finished motor gasoline may be further mixed with other motor gasoline blending components or oxygenates, resulting in increased volumes of finished motor gasoline and/or changes in the formulation of finished motor gasoline (e.g., conventional motor gasoline mixed with ethanol or another other octane booster to produce oxygenated motor gasoline).',
		],
	},
	{
		title: 'Motor Gasoline Blending Components',
		content: [
			'Naphthas (e.g., straight-run gasoline, alkylate, reformate, benzene, toluene, xylenes) used for blending or compounding into finished motor gasoline. These components include reformulated gasoline blendstock for oxygenate blending (RBOB) but exclude oxygenates (alcohols, ethers), butane, and pentanes.',
			'Note: Oxygenates are reported as individual components and are included in the total for other hydrocarbons and oxygenates.',
		],
	},
	{
		title: 'N-Grade',
		content: [
			'A Magellan Pipeline designation for clear regular unleaded gasoline.',
			'Naked Option:',
			'Sale of an option (either a put or a call) without ownership of the underlying futures contract.',
		],
	},
	{
		title: 'Naphtha',
		content: [
			'A petroleum product off of the distillation process (220°F to 315°F) that is subsequently upgraded to make up the major constituent of gasoline.',
		],
	},
	{
		title: 'Naphtha Less Than 401o F',
		content: [
			'A naphtha with a boiling range of less than 401 degrees Fahrenheit that is intended for use as a petrochemical feedstock.',
		],
	},
	{
		title: 'Naphtha-Type Jet Fuel',
		content: [
			'A fuel in the heavy naphtha boiling range having an average gravity of 52.8 degrees API, 20 to 90% distillation temperatures of 290 degrees to 470 degrees Fahrenheit, and meeting Military Specification MIL-T-5624L (Grade JP-4). It is used primarily for military turbojet and turboprop aircraft engines because it has a lower freeze point than other aviation fuels and meets engine requirements at high altitudes and speeds.',
			'Note: Beginning with January 2004 data, naphtha-type jet fuel is included in Miscellaneous Products.',
		],
	},
	{
		title: 'National Futures Association (NFA)',
		content: [
			'Trade association which is responsible for promoting and monitoring rules of conduct, and which mediates disputes between customers and brokers. One of the regulatory bodies which oversees futures trading.',
		],
	},
	{
		title: 'Nation’s Freight Bill',
		content: [
			'The amount spent annually on freight transportation by the nation’s shippers and also represents the total revenue of all carriers operating in the nation.',
		],
	},
	{
		title: 'Natural Gas',
		content: [
			'A naturally-occurring raw material often produced in conjunction with crude oil that is processed through a variety of facilities to yield NGLs. It is a commercially acceptable product for industrial and residential consumption and is shipped via pipeline.',
		],
	},
	{
		title: 'Natural Gas Field Facility',
		content: [
			'A field facility designed to process natural gas produced from more than one lease for the purpose of recovering condensate from a stream of natural gas. However, some field facilities are designed to recover propane, normal butane, natural gasoline, etc., and to control the quality of natural gas to be marketed.',
		],
	},
	{
		title: 'Natural Gas Liquids (NGLs)',
		content: [
			'Those hydrocarbons in natural gas that are separated from the gas as liquids through the process of absorption, condensation, adsorption, or other methods in gas processing or cycling plants. Generally such liquids consist of propane and heavier hydrocarbons and are commonly referred to as lease condensate, natural gasoline, and liquefied petroleum gases. Natural gas liquids include natural gas plant liquids (primarily ethane, propane, butane, and isobutane. See Natural Gas Plant Liquids) and lease condensate (primarily pentanes produced from natural gas at lease separators and field facilities. See Lease Condensate).',
		],
	},
	{
		title: 'Natural Gas Plant Liquids',
		content: [
			'Those hydrocarbons in natural gas that are separated as liquids at natural gas processing plants, fractionating and cycling plants, and, in some instances, field facilities. Lease condensate is excluded. Products obtained include ethane, liquefied petroleum gases (propane, butanes, propane-butane mixtures, ethane-propane mixtures), isopentane, and other small quantities of finished products, such as motor gasoline, special naphthas, jet fuel, kerosene, and distillate fuel oil.',
		],
	},
	{
		title: 'Natural Gas Processing Plant',
		content: [
			'Facilities designed to recover natural gas liquids from a stream of natural gas that may or may not have passed through lease separators and/ or field separation facilities. These facilities control the quality of the natural gas to be marketed. Cycling plants are classified as gas processing plants.',
		],
	},
	{
		title: 'Natural Gasoline And Isopentane',
		content: [
			'A mixture of hydrocarbons, mostly pentanes and heavier, extracted from natural gas, that meets vapor pressure, end-point, and other specifications for natural gasoline set by the Gas Processors Association. Includes isopentane which is a saturated branch-chain hydrocarbon obtained by fractionation of natural gasoline or isomerization of normal pentane.',
		],
	},
	{
		title: 'Net',
		content: ['Prices include any available prompt payment discounts.'],
	},
	{
		title: 'Net Average',
		content: [
			'An average of all rack suppliers, calculated with any prepayment discount reduced from the applicable suppliers.',
		],
	},
	{
		title: 'Net Receipts',
		content: [
			'The difference between total movements into and total movements out of each PAD District by pipeline, tanker, and barge.',
		],
	},
	{
		title: 'Net Profit Margin',
		content: [
			'A measure of profitability based on the ratio of net income to total operating revenues. Netbacks: The price a refiner receives for the sale of petroleum products after deducting the transportation or affiliated costs in shipping the product from its point of origin (i.e., pipeline tariffs, waterborne freight, storage fees, line loss, cost of capital, etc.). ',
		],
	},
	{
		title: 'Netback Differential',
		content: [
			'The difference between the spot and rack prices for refined petroleum products.',
		],
	},
	{
		title: 'Netback Pricing Or Agreements',
		content: [
			'Contractual crude oil arrangements very prevalent during the mid-80’s which set the sales price of crude oil on the value of the derivative petroleum products.',
		],
	},
	{
		title: 'Nomination',
		content: [
			'The notification by the seller of a spot market obligation of the attempt to deliver the product to satisfy the commitment.',
		],
	},
	{
		title: 'Non-TET',
		content: [
			'Price designation which only applies to product traded in the Mont Belvieu Caverns facility that is a subsidiary of Enterprise Products Partners, LP.',
		],
	},
	{
		title: 'NOPEC',
		content: [
			'A group of independent crude oil producing nations that are not members of OPEC, but have collectively restricted production levels in support of OPEC. Includes Malaysia, Mexico, Oman, Egypt, Angola, China and Columbia.',
		],
	},
	{
		title: 'New York Mercantile Exchange (NYMEX)',
		content: [
			'Exchange where a number of commodities, including WTI crude, heating oil and unleaded gasoline are traded on a future basis.',
		],
	},
	{
		title: 'NYMEX',
		content: ['The New York Mercantile Exchange.'],
	},
	{
		title: 'Natural gas',
		content: [
			'Naturally occurring hydrocarbon gases found in porous rock formations. Its principal component is usually methane.',
			'Nonhydrocarbon gases such as carbon dioxide and hydrogen sulfide can sometimes be present in natural gas. For more information, view our fact sheets at www.powerincooperation.com.',
		],
	},
	{
		title: 'Natural gas liquids (NGLs)',
		content: [
			'A general term for highly volatile liquid products separated from natural gas in a gas processing plant. NGLs include ethane, propane, butane and condensate.',
		],
	},
	{
		title: 'Net acres',
		content: [
			'The percentage that a company owns in an acreage position with multiple owners. For example, a company that has a 50 percent interest in a lease covering 10,000 acres owns 5,000 net acres.',
		],
	},
	{
		title: 'Oil, Chemical and Atomic Workers Union (OCAW)',
		content: [
			'The principal labor group at U.S. refineries. Refinery strikes are generally called by this union or its affiliates.',
		],
	},
	{
		title: 'Octane',
		content: [
			'A measure of the performance quality of gasoline in terms of antiknock qualities. The higher the octane number, the greater the antiknock qualities.',
		],
	},
	{
		title: 'Off-Road Diesel',
		content: [
			'Nothing more than high-sulfur No. 2 oil – same as home heating oil. This fuel can be used for off-road purposes such as powering diesel construction equipment.',
		],
	},
	{
		title: 'Offshore Block',
		content: [
			'Refers to a designated piece of property in a body of water for mineral exploration. The Gulf of Mexico has many “areas” that are divided up into blocks to be leased to companies for exploration.',
		],
	},
	{
		title: 'Open Interest',
		content: [
			'Figures published by the NYMEX which indicate the number of outstanding positions in a futures contract. An open interest number of 100,000 means that there are 50,000 long and 50,000 outstanding short positions. Rises or falls in open interest are often key barometers of whether a market is rising/falling thanks to new buying/selling or liquidation by existing participants. A rise in open interest after a market rally is often indicative of new buying, whereas a fall would have been representative of short covering.',
		],
	},
	{
		title: 'Open Order',
		content: [
			'An order to buy or sell a futures contract or option which is good until it is canceled. An order to buy crude at say $19/bbl, will be good until it’s filled, with the brokerage house typically checking with clients at various intervals to see if there is interest in changing the order.',
		],
	},
	{
		title: 'Opening',
		content: [
			'The period at the beginning of a trading session as designated by the exchange.',
		],
	},
	{
		title: 'Open Outcry',
		content: [
			'A public auction form of futures trading where bids and offers are made directly between traders in an exchange pit.',
		],
	},
	{
		title: 'Operable Capacity',
		content: [
			'The component of operable capacity that is in operation at the beginning of the period.',
		],
	},
	{
		title: 'Operable Utilization Rate',
		content: [
			'Represents the utilization of the atmospheric crude oil distillation units. The rate is calculated by dividing the gross input to these units by the operating refining capacity of the units.',
		],
	},
	{
		title: 'Operating Expenses',
		content: [
			'The costs of handling traffic, including both direct costs (driver wages and fuel) and indirect costs (computer expenses and advertising), but excluding interest expenses.',
		],
	},
	{
		title: 'Operating Ratio',
		content: [
			'A measure of profitability based on operating expenses as a percentage of gross revenues.',
		],
	},
	{
		title: 'OPIS Benchmark Averages',
		content: [
			'Published averages commonly used as a basis for buying/ selling fuel: contract (10:00 a.m. ET), closing daily averages (5:59 p.m. ET), newsletter and 5-day averages published in the weekly OPIS newsletter.',
		],
	},
	{
		title: 'OPIS Calendar-Day Average',
		content: [
			'A snapshot of the average of all supplier postings in each OPIS rack market at 11:59 p.m. ET. The snapshot includes all price moves from 12:00 a.m. (midnight ET) until the file is frozen at 11:59 p.m. ET. (Example: The January 8th Calendar-Day Average encompasses all price moves that were made from 12:00 a.m. (midnight ET) on January 8th up through 11:59 p.m. ET on January 8th. Hence, it is an average of all prices on that calendar day.)',
		],
	},
	{
		title: 'OPIS Closing Average',
		content: [
			'A snapshot of the average of all supplier postings in each OPIS rack market at 5:59 p.m. ET. The snapshot includes all price moves from 6:00 p.m. ET the prior day until the price file is frozen by 5:59 p.m. (Example: The January 8th Closing Average encompasses all price moves that were made at 6:00 p.m. ET. January 7th up until we freeze the prices no later than 5:59 p.m. ET on January 8th. It does not include any price moves made at or later than 6:00 p.m. ET on January 8th.)',
		],
	},
	{
		title: 'OPIS Contract Average',
		content: [
			'A snapshot of the average of all supplier postings in each OPIS rack market at approximately 10:00 a.m. ET. The snapshot includes all price moves from 6:00 p.m. ET the prior day up until the price file is frozen at approximately 10:00 a.m. ET. (Example: The January 8th Contract Average encompasses all price moves that were made at 6:00 p.m. ET January 7th up until approximately 10:00 a.m. ET January 8th.)',
		],
	},
	{
		title: 'OPIS High',
		content: [
			'The highest supplier price at that particular rack on that day. Available in standard, newsletter, and/or terminal display',
		],
	},
	{
		title: 'OPIS Last',
		content: [
			'The OPIS ‘Last’ is a price indicator of where cash or spot market prices end for each full-day spot market trading session. It provides a numerical approximation of a refined products end-of-the day value (this part seems to refer more to the change in the last rather than the last).',
		],
	},
	{
		title: 'OPIS Low',
		content: [
			'The lowest supplier price at that particular rack on that day. Available in standard, newsletter, and/or terminal display',
		],
	},
	{
		title: 'OPIS Mean',
		content: [
			'The OPIS Spot ‘Mean’ represents the numerical mid-point of the OPIS “low” and the OPIS "high” calculated using actual spot market deals confirmed by OPIS markets editors during the course of full-day trading.',
		],
	},
	{
		title: 'OPIS Newsletter Average',
		content: [
			'The published Thursday evening average (except on certain holiday weeks) in the printed OPIS newsletter. This average is ALWAYS gross. The OPIS Newsletter started in 1980 when the market moved only once a week. Since major fuel purchases are referenced to this published price, it is one of many benchmarks available from OPIS today.',
		],
	},
	{
		title: 'OPIS Rack Prices',
		content: [
			'A daily (Mon-Sat), independent, published survey of supplier prices without taxes, freight or superfund for gasoline and diesel fuel at over 360 U.S. rack distribution points.',
		],
	},
	{
		title: 'OPIS Spot Mean',
		content: [
			'The OPIS Spot Mean represents the numerical mid-point of the OPIS Low and the OPIS High calculated using actual spot market deals confirmed by OPIS markets editors during the course of full-day trading.',
		],
	},
	{
		title: 'OPIS Standard Display',
		content: [
			'Shows one price per product per supplier for all suppliers in that rack city. OPIS uses the primary terminal for suppliers with multiple terminals to avoid skewing the OPIS average for benchmarking purposes.',
		],
	},
	{
		title: 'OPIS Terminal Display',
		content: [
			'Shows all terminals at a given location for every supplier by product. The OPIS Terminal Display includes terminal location and terminal owner.',
		],
	},
	{
		title: 'Option',
		content: [
			'A contract traded on a futures exchange giving the buyer the right, but not the obligation, to buy (a call option) or sell (a put option) a specific quantity of a commodity from the seller or writer of the option.',
		],
	},
	{
		title: 'Organization of Petroleum Exporting Countries (OPEC)',
		content: [
			'Countries which have organized for the purpose of negotiating with oil companies on matters of oil production, prices and future concession rights. Current members are Algeria, Indonesia, Iran, Iraq, Kuwait, Libya, Nigeria, Qatar, Saudi Arabia, the United Arab Emirates and Venezuela. The Neutral Zone between Kuwait and Saudi Arabia is considered part of OPEC. Prior to January 1, 1993, Ecuador was a member of OPEC. Prior to January 1995, Gabon was a member of OPEC.',
		],
	},
	{
		title: 'Other Hydrocarbons',
		content: [
			'Materials received by a refinery and consumed as a raw material. Includes hydrogen, coal tar derivatives, gilsonite, and natural gas received by the refinery for reforming into hydrogen. Natural gas to be used as fuel is excluded.',
		],
	},
	{
		title: 'Other Oils Equal to or Greater Than 401o F',
		content: [
			'Oils with a boiling range equal to or greater than 401 degrees Fahrenheit that are intended for use as a petrochemical feedstock.',
		],
	},
	{
		title: 'Other Oxygenates',
		content: [
			'Other aliphatic alcohols and aliphatic ethers intended for motor gasoline blending (e.g., isopropyl ether (IPE) or n-propanol). Oxygenated Gasoline. See Motor Gasoline (Finished).',
		],
	},
	{
		title: 'Out Month',
		content: [
			'OPIS prices labeled as “out month” represent transactions for product that buyer and seller agree will be delivered any time in the next calendar month.',
		],
	},
	{
		title: 'Out-of-Product',
		content: [
			'OPIS marks “out-of-product” if a rack supplier’s product is confirmed unavailable for more than 24 hours. Postings which meet this criteria will be designated “out-of-product” with an “o” next to the listing, and these numbers will not be part of the OPIS lows, highs or averages.',
		],
	},
	{
		title: 'Out of the Money Option',
		content: [
			'Refers to an option where the futures price is less than the strike price for the appropriate call, or higher than the strike price for puts.',
		],
	},
	{
		title: 'Over the Rack',
		content: [
			'Petroleum products sold at the wholesale level from primary storage. Refers to loading racks where tanker trucks fill up. Also Rack Market.',
		],
	},
	{
		title: 'Overbought',
		content: [
			'A trading term used to express the opinion that prices have escalated rapidly, and therefore are subject to a sell-off as positions are liquidated. Oversold: The opposite of overbought.',
		],
	},
	{
		title: 'Oxygenated Fuels',
		content: [
			'Non-hydrocarbon additives—including MTBE, ethanol and methanol—which boost octane and produce a cleaner combustion.ulated gasoline, having an oxygen content of 2.7% or higher by weight.',
		],
	},
	{
		title: 'Oxygenated Gasoline',
		content: [
			'Finished motor gasoline, other than reformulated gasoline, having an oxygen content of 2.7% or higher by weight.',
		],
	},
	{
		title: 'Oxygenates',
		content: [
			'Substances which, when added to gasoline, increase the amount of oxygen in that gasoline blend. Fuel Ethanol, Ethyl Tertiary Butyl Ether (ETBE), and methanol are common oxygenates.',
			'● Fuel ethanol: Blends of up to 10% by volume anhydrous ethanol (200 proof) (commonly referred to as the “gasohol waiver”). ',
			'● Methanol: Blends of methanol and gasoline-grade tertiary butyl alcohol (GTBA) such that the total oxygen content does not exceed 3.5% by weight and the ratio of methanol to GTBA is less than or equal to 1. It is also specified that this blended fuel must meet ASTM volatility specifications (commonly referred to as the “ARCO” waiver). Blends of up to 5.0% by volume methanol with a minimum of 2.5% by volume cosolvent alcohols having a carbon number of 4 or less (i.e., ethanol, propanol, butanol, and/or GTBA). The total oxygen must not exceed 3.7% by weight, and the blend must meet ASTM volatility specifications as well as phase separation and alcohol purity specifications (commonly referred to as the “DuPont” waiver).',
		],
	},
	{
		title: 'Oil sands',
		content: [
			'Geologic formation comprised predominantly of sand grains and bitumen, a highly viscous form of crude oil.',
		],
	},
	{
		title: 'Operator',
		content: [
			'The entity responsible for managing operations in a field or undeveloped acreage position.',
		],
	},
	{
		title: 'Qualified facility (QF)',
		content: [
			'A generator or small power producer that meets certain ownership, operating, and efficiency criteria established by the Federal Energy Regulatory Commission (FERC), and has filed with FERC for QF status or has self-certified. QFs are physical generating facilities.',
		],
	},
	{
		title: 'Quality or grade',
		content: [
			'• An informal classification of coal relating to its suitability for use for a particular purpose.',
			'• Individual measurements such as heat value, fixed carbon, moisture, ash, sulphur, major, minor, and trace elements, coking properties, petrologic properties, and particular organic constituents. The individual quality elements may be aggregated in various ways to classify coal for such special purposes as metallurgical, gas, petrochemical, and blending usages. ',
		],
	},
	{
		title: 'Quanto product',
		content: [
			'An asset or liability denominated in a currency other than that in which it is usually traded. Since the combined exposure to the asset and to the foreign exchange rate will change continuously, the structures must be dynamically hedged',
		],
	},
	{
		title: 'Permeability',
		content: [
			'The permeability of a rock is the measure of the resistance to the flow of fluid through the rock. High permeability means fluid passes through the rock easily.',
		],
	},
	{
		title: 'Pentanes Plus',
		content: [
			'A mixture of hydrocarbons, mostly pentanes and heavier, extracted from natural gas. Includes isopentane, natural gasoline, and plant condensate.',
		],
	},
	{
		title: 'Persian Gulf',
		content: [
			'The countries that comprise the Persian Gulf are: Bahrain, Iran, Iraq, Kuwait, Qatar, Saudi Arabia, and the United Arab Emirates.',
		],
	},
	{
		title: 'Petrochemical Feedstocks',
		content: [
			'Chemical feedstocks derived from petroleum principally for the manufacture of chemicals, synthetic rubber, and a variety of plastics. The categories reported are cNaphtha Less Than 401° FN and Other Oils Equal To or Greater Than 401° FG.',
		],
	},
	{
		title: 'Petroleum Administration for Defense Districts (PADD)',
		content: [
			'Five geographic areas into which the United States was divided by the Petroleum Administration for Defense for purposes of administration during federal price controls or oil allocation.',
			'They are:',
			'● PADD1: Connecticut, Delaware, District of Columbia, Florida, Georgia, Maine, Maryland, Massachusetts, New Hampshire, New Jersey, New York, North Carolina, Pennsylvania, Rhode Island, South Carolina, Vermont, Virginia and West Virginia.',
			'● PADD2: Illinois, Indiana, Iowa, Kansas, Kentucky, Michigan, Minnesota, Missouri.',
			'● Nebraska, North Dakota, Ohio, Oklahoma, South Dakota, Tennessee and Wisconsin.',
			'● PADD3: Alabama, Arkansas, Louisiana, Mississippi, New Mexico and Texas.',
			'● PADD4: Colorado, Idaho, Montana, Utah and Wyoming.',
			'● PADD5: Alaska, Arizona, California, Hawaii, Nevada, Oregon and Washington.',
		],
	},
	{
		title: 'Petrochemical',
		content: [
			'An intermediate product derived from crude and natural gas processing that is used in production of a wide range of products, including plastics. Also the facility that processes these intermediate products. Petrochemical plants are often integrated with major refineries.',
		],
	},
	{
		title: 'Petroleum Coke',
		content: [
			'A residue high in carbon content and low in hydrogen that is the final product of thermal decomposition in the condensation process in cracking. This product is reported as marketable coke. The conversion is 5 barrels (of 42 U.S. gallons each) per short ton. Coke from petroleum has a heating value of 6.024 million Btu per barrel.',
			'● Catalyst coke: The only catalytic coke used as a fuel is the coke on catalyst in the FCC process. In other catalytic processes there is coke deposited on the catalyst, but it is not regenerated in such a way that the heat of combustion is recovered.',
			'● Marketable coke: Those grades of coke produced in delayed or fluid cokers which may be recovered as relatively pure carbon. This “green” coke may be sold as is or further purified by calcining',
		],
	},
	{
		title: 'Petroleum Products',
		content: [
			'Petroleum products are obtained from the processing of crude oil (including lease condensate), natural gas, and other hydrocarbon compounds. Petroleum products include unfinished oils, liquefied petroleum gases, pentanes plus, aviation gasoline, motor gasoline, naphtha-type jet fuel, kerosene-type jet fuel, kerosene, distillate fuel oil, residual fuel oil, petrochemical feedstocks, special naphthas, lubricants, waxes, petroleum coke, asphalt, road oil, still gas, and miscellaneous products.',
		],
	},
	{
		title: 'Piggyback',
		content: [
			'The transportation of highway trailers or removable trailer bodies on rail cars specifically equipped for the service. It is essentially a joint carrier movement in which the motor carrier forms a pickup and delivery operation to a rail terminal, as well as a delivery operation at the terminating rail head.',
		],
	},
	{
		title: 'Pipeline Tender',
		content: ['See Batch.'],
	},
	{
		title: 'Pipelines',
		content: [
			'A network that allows crude oil, refined products and gas liquids to move across the country, usually from either refineries to terminals or from coastal (import) locations to terminals and refineries further inland.',
		],
	},
	{
		title: 'Pit Trading',
		content: [
			'Trading conducted within the normal hours of the NYMEX inside the open outcry pits. Pit hours are generally 9:45 a.m. to 3:10 p.m. ET for most contracts. With the advent of overnight or after hours trading on the ACCESS automated system, it has become necessary to identify pit trading.',
		],
	},
	{
		title: 'Plant Condensate',
		content: [
			'One of the natural gas liquids, mostly pentanes and heavier hydrocarbons, recovered and separated as liquids at gas inlet separators or scrubbers in processing plants.',
		],
	},
	{
		title: 'Platform',
		content: [
			'A structure that draws fuel from an underground source. Usually referring to an offshore rig that also transmits fuel from that location via pipeline.',
		],
	},
	{
		title: 'Point',
		content: ['1/100th of a cent ($0.0001).'],
	},
	{
		title: 'Position Limit ',
		content: [
			'The maximum number of allowable open contracts for a single trader or a firm in a given futures contract.',
		],
	},
	{
		title: 'Primary Storage',
		content: [
			'Petroleum storage tanks at refineries, pipelines and oil company terminals. Product inventory changes at these facilities are what constitute API and EIA demand computations. See also secondary and tertiary storage.',
		],
	},
	{
		title: 'Processing Gain',
		content: [
			'The volumetric amount by which total output is greater than input for a given period of time. This difference is due to the processing of crude oil into products which, in total, have a lower specific gravity than the crude oil processed.',
		],
	},
	{
		title: 'Processing Loss',
		content: [
			'The volumetric amount by which total refinery output is less than input for a given period of time. This difference is due to the processing of crude oil into products which, in total, have a higher specific gravity than the crude oil processed.',
		],
	},
	{
		title: 'Product Authorization',
		content: [
			'Authorization by a shipper in a pipeline allowing another supplier to draw product on account, either on a limited or unlimited basis.',
		],
	},
	{
		title: 'Production Capacity',
		content: [
			'The maximum amount of product that can be produced from processing facilities.',
		],
	},
	{
		title: 'Product Supplied, Crude Oil',
		content: ['Crude oil burned on leases and by pipelines as fuel.'],
	},
	{
		title: 'Products Supplied',
		content: [
			'Approximately represents consumption of petroleum products because it measures the disappearance of these products from primary sources, i.e., refineries, natural gas processing plants, blending plants, pipelines, and bulk terminals. In general, product supplied of each product in any given period is computed as follows: field production, plus refinery production, plus imports, plus unaccounted for crude oil, (plus net receipts when calculated on a PADD basis), minus stock change, minus crude oil losses, minus refinery inputs, minus exports.',
		],
	},
	{
		title: 'Prompt',
		content: [
			'Term used in reference to wet bbl delivery timetable. OPIS prices recognize the “prompt” timeframe as signifying delivery in the earliest possible pipeline cycle slot, or for waterborne pickup of material available in the next 24-72 hours.',
		],
	},
	{
		title: 'Prompt Current Month',
		content: [
			'OPIS prices labeled as “prompt current month” represent transactions for product that buyer and seller agree will be delivered within the next 48 hours.',
		],
	},
	{
		title: 'Prompt Delivery (prompts)',
		content: [
			'Designates a spot market delivery that must be made in the next few days as stipulated by the contract.',
		],
	},
	{
		title: 'Product Transfer Order (PTO)',
		content: [
			'Pipeline authorizations transferring title to a set quantity of product at a specific location to another shipper.',
		],
	},
	{
		title: 'Propane (C3H8)',
		content: [
			'A normally gaseous straight-chain hydrocarbon. It is a colorless paraffinic gas that boils at a temperature of -43.67 degrees Fahrenheit. It is extracted from natural gas or refinery gas streams. It includes all products designated in ASTM Specification D1835 and Gas Processors Association Specifications for commercial propane and HD-5 propane.',
		],
	},
	{
		title: 'Propylene (C3H6)',
		content: [
			'An olefinic hydrocarbon recovered from refinery processes or petrochemical processes.',
		],
	},
	{
		title: 'Propylene (C3H6) (nonfuel use)',
		content: [
			'Propylene that is intended for use in nonfuel applications such as petrochemical manufacturing. Nonfuel use propylene includes chemical-grade propylene, polymer-grade propylene, and trace amounts of propane. Nonfuel use propylene also includes the propylene component of propane/ propylene mixes where the propylene will be separated from the mix in a propane/ propylene splitting process. Excluded is the propylene component of propane/ propylene mixes where the propylene component of the mix is intended for sale into the fuel market.',
		],
	},
	{
		title: 'Put Option',
		content: [
			'Also referred to simply as a “put.” Refers to an option which gives the buyer the right, but not the obligation, to sell a futures contract at a specified strike price.',
		],
	},
	{
		title: 'Play',
		content: [
			'An area in which hydrocarbon accumulations or prospects with similar characteristics occur, such as the Lower Tertiary play in the deepwater Gulf of Mexico or the Marcellus play in the eastern United States.',
		],
	},
	{
		title: 'Porosity',
		content: [
			'The measure of a rock’s ability to hold a fluid. Porosity is normally expressed as a percentage of the total rock which is taken up by pore space.',
		],
	},
	{
		title: 'Possible reserves',
		content: [
			'Additional reserves that are less certain to be recovered than probable reserves.',
		],
	},
	{
		title: 'Probable reserves',
		content: [
			'Additional reserves that are less certain to be recovered than proved reserves but which, together with proved reserves, are as likely as not to be recovered.',
		],
	},
	{
		title: 'Produced water',
		content: [
			'Water produced in connection with oil and natural gas exploration and development activities.',
		],
	},
	{
		title: 'Production sharing contract (PSC)',
		content: [
			'An agreement between a host government and the owners (or co-owners) of a well or field regarding the percentage of production each party will receive after the parties have recovered a specified amount of capital and operational expenses.',
		],
	},
	{
		title: 'Productive well',
		content: [
			'A well that is capable of producing hydrocarbons in sufficient quantities to justify commercial exploitation.',
		],
	},
	{
		title: 'Proppant',
		content: [
			'Sand or man-made, sand-sized particles pumped into a formation during a hydraulic fracturing treatment to keep fractures open so that oil and natural gas can flow through the fractures to the wellbore.',
		],
	},
	{
		title: 'Proved developed reserves',
		content: [
			'Proved reserves that can be expected to be recovered through existing wells with existing equipment and operating methods or in which the cost of the required equipment is relatively minor compared to the cost of a new well.',
		],
	},
	{
		title: 'Proved reserves',
		content: [
			'Proved oil and gas reserves are those quantities of oil and gas which, by analysis of geoscience and engineering data, can be estimated with reasonable certainty to be economically producible – as defined by the U.S. Securities and Exchange Commission regulations and the ConocoPhillips Policy for Reserves Estimation, Accounting and Reporting.',
		],
	},
	{
		title: 'RBOB (reformulated blendstock for oxygenate blending)',
		content: [
			'Specially produced reformulated gasoline blendstock intended for blending with oxygenates downstream of the refinery where it was produced. Includes RBOB used to meet requirements of the Federal reformulated gasoline program and other blendstock intended for blending with oxygenates to produce finished gasoline that meets or exceeds emissions performance requirements of Federal reformulated gasoline (e.g. California RBOB and Arizona RBOB). Excludes conventional gasoline blendstocks for oxygenate blending (CBOB).',
		],
	},
	{
		title: 'Rack Market',
		content: [
			'Petroleum products sold at the wholesale level from primary storage. Refers to loading racks where tanker trucks fill up. Also Over the Rack.',
		],
	},
	{
		title: 'Raffinate',
		content: [
			'The residual product left after a reforming process. The term also has been more generally used in reference to any low octane product left over after any secondary refining process. Preferable to natural gasoline in ethanol/gasoline blends because of the low RVP (4 to 8).',
		],
	},
	{
		title: 'Regulated Motor Carrier',
		content: [
			'A carrier subject to economic regulation by the Department of Transportation.',
		],
	},
	{
		title: 'Refinery',
		content: [
			'An installation that manufacturers finished petroleum products from crude oil, unfinished oils, natural gas liquids, other hydrocarbons and oxygenates.',
		],
	},
	{
		title: 'Refinery-Grade Butane (C4H10)',
		content: [
			'A refinery-produced stream that is composed predominantly of normal butane and/or isobutane and may also contain propane and/ or natural gasoline. These streams may also contain significant levels of olefins and/or fluorides contamination.',
		],
	},
	{
		title: 'Refinery Input, Crude Oil',
		content: [
			'Total crude oil (domestic plus foreign) input to crude oil distillation units and other refinery processing units (cokers, etc.).',
		],
	},
	{
		title: 'Refinery Input, Total',
		content: [
			'The raw materials and intermediate materials processed at refineries to produce finished petroleum products. They include crude oil, products of natural gas processing plants, unfinished oils, other hydrocarbons and oxygenates, motor gasoline and aviation gasoline blending components and finished petroleum products.',
		],
	},
	{
		title: 'Refinery Production',
		content: [
			'Petroleum products produced at a refinery or blending plant. Published production of these products equals refinery production minus refinery input. Negative production will occur when the amount of a product produced during the month is less than the amount of that same product that is reprocessed (input) or reclassified to become another product during the same month. Refinery production of unfinished oils, and motor and aviation gasoline blending components appear on a net basis under refinery input.',
		],
	},
	{
		title: 'Refinery Yield',
		content: [
			'Refinery yield (expressed as a percentage) represents the percent of finished product produced from input of crude oil and net input of unfinished oils. It is calculated by dividing the sum of crude oil and net unfinished input into the individual net production of finished products. Before calculating the yield for finished motor gasoline, the input of natural gas liquids, other hydrocarbons and oxygenates, and net input of motor gasoline blending components must be subtracted from the net production of finished motor gasoline. Before calculating the yield for finished aviation gasoline, input of aviation gasoline blending components must be subtracted from the net production of finished aviation gasoline.',
		],
	},
	{
		title: 'Reforming',
		content: [
			'An oil refining unit in which naphthas are changed chemically to increase their octane level. Paraffins convert to iso-paraffins and naphthenes, and naphthenes change to aromatics. The catalyst used is usually platinum, though sometimes palladium.',
		],
	},
	{
		title: 'Reid Vapor Pressure (RVP)',
		content: [
			'The volatility or tendency of a petroleum product to evaporate. The lower the number, the more stable the product. RVP is used to measure pressure in terms of pounds per square inch (psi). In terms of gasoline, RVP is used as an ozone control mechanism.',
		],
	},
	{
		title: 'Renewable Identification Number (RIN)',
		content: [
			'A serial number assigned to a batch of biofuel for the purpose of tracking its production, use, and trading as required by the EPA’s renewable fuels standard (RFS). The EPA is authorized to set annual quotas dictating what percentage of the total amount of motor fuels consumed in the U.S. must be represented by biofuel blended into fossil fuels. Companies that refine, import or blend fossil fuels are obligated to meet certain individual RFS quotas based on the volume of fuel they introduce into the market. To ensure compliance, obligated parties are periodically required to demonstrate they have met their RFS quota by submitting a certain amount of RINs to the EPA. Because each of these RINs represent an amount of biofuel that has been blended into fossil fuels, the RINs submitted to the EPA by obligated parties are a quantitative representation of the amount of biofuel that has been blended into the fossil fuels used in America.',
		],
	},
	{
		title: 'Residual Fuel Oil',
		content: [
			'A general classification for the heavier oils, known as No. 5 and No. 6 fuel oils, that remain after the distillate fuel oils and lighter hydrocarbons are distilled away in refinery operations. It conforms to ASTM Specifications D 396 and D 975 and Federal Specification VV-F-815C. No. 5, a residual fuel oil of medium viscosity, is also known as Navy Special and is defined in Military Specification MIL-F-859E, including Amendment 2 (NATO Symbol F-770). It is used in steam-powered vessels in government service and inshore power plants. No. 6 fuel oil includes Bunker C fuel oil and is used for the production of electric power, space heating, vessel bunkering, and various industrial purposes.',
		],
	},
	{
		title: 'Residuum',
		content: [
			'Residue from crude oil after distilling off all but the heaviest components, with a boiling range greater than 1000 degrees Fahrenheit. Road Oil. Any heavy petroleum oil, including residual asphaltic oil used as a dust palliative and surface treatment on roads and highways. It is generally produced in six grades from 0, the most liquid, to 5, the most viscous.',
		],
	},
	{
		title: 'Resistance',
		content: [
			'A technical level where the current price of a commodity will have difficulty penetrating on a price trend.',
		],
	},
	{
		title: 'Reverse Crack Spread',
		content: [
			'A spread trade implemented when a speculator thinks refiner margins will narrow. Product contracts are bought against crude contracts sold. See Crack Spread.',
		],
	},
	{
		title: 'Round Turn',
		content: [
			'Both sides of a futures contract. When a commission is paid for a futures transaction, it is usually paid on a “round turn” basis where it covers both the purchase and sale.',
		],
	},
	{
		title: 'Rotterdam',
		content: [
			'A port in the Netherlands. The most prevalent transaction point for spot market petroleum on the European continent. The second largest refining center in the world after Houston.',
		],
	},
	{
		title: 'Reasonable certainty',
		content: [
			'A high degree of certainty. Much more likely to be achieved than not.',
		],
	},
	{
		title: 'Recompletion',
		content: [
			'The process of entering an existing wellbore and performing work designed to establish production from a new zone.',
		],
	},
	{
		title: 'Recordable cases',
		content: [
			'As related to health, safety and environment (HSE), recordable cases include occupational death, nonfatal occupational illness and those nonfatal occupational injuries which involve one or more of the following: loss of consciousness, restriction of work or motion, transfer to another job or medical treatment (other than first aid).',
		],
	},
	{
		title: 'Reserves',
		content: [
			'Estimated remaining quantities of oil and gas and related substances anticipated to be economically producible, as of a given date, by application of development projects to known accumulations. In addition, there must exist, or there must be a reasonable expectation that there will exist, the legal right to produce or a revenue interest in production, installed means of delivering oil and gas or related substances to market and all permits and financing required to implement the project.',
		],
	},
	{
		title: 'Reservoir',
		content: [
			'A porous and permeable underground formation containing a natural accumulation of producible oil and/or gas that is confined by impermeable rock or water barriers and is individual and separate from other reservoirs.',
		],
	},
	{
		title: 'Resources',
		content: [
			'Quantities of oil and gas estimated to exist in naturally occurring accumulations. A portion of the resources may be estimated to be recoverable, and another portion may be considered to be unrecoverable. Resources include both discovered and undiscovered accumulations.',
		],
	},
	{
		title: 'Return on capital employed (ROCE)',
		content: [
			'ROCE is a measure of the profitability of a company’s capital employed in its business compared with that of its peers. ROCE is calculated as a ratio, with the numerator of net income plus after-tax interest expense and the denominator of average total equity plus total debt. The net income is adjusted for nonoperational or special items impacts.',
		],
	},
	{
		title: 'Saudi Aramco',
		content: [
			'The Saudi Arabian Oil Company, the national oil company of Saudi Arabia.',
		],
	},
	{
		title: 'Secondary Storage',
		content: [
			'Petroleum storage tanks consisting of retail gas stations, bulk plants and commercial storage.',
		],
	},
	{
		title: 'Settlement/Settling Price',
		content: [
			'The price established by the Exchange Settlement Committee at the close of each trading session as the official price that will be used by the clearing house in determining net gains or losses on the day. The settlement or settling price provides the benchmark by which margin requirements and the next day’s price limits are made. There are frequently significant variations between closing prices - those trades witnessed immediately before the closing bell, and the settlement prices.',
		],
	},
	{
		title: 'Shell Storage Capacity',
		content: [
			'The design capacity of a petroleum storage tank which is always greater than or equal to working storage capacity.',
		],
	},
	{
		title: 'Short',
		content: [
			'Having an outstanding position to sell a wet bbl or a futures contract. A speculative “short” trader would be hopeful of a market decline so he could eventually buy back his bbl at a lower price. A market with too many short traders is often described as oversold.',
		],
	},
	{
		title: 'Short Covering',
		content: [
			'Description which usually pertains to a market where speculative shorts are covering or canceling out their positions by buying product. A rally from short covering is not indicative of new buying and is often violent but brief.',
		],
	},
	{
		title: 'Special Naphthas',
		content: [
			'All finished products within the naphtha boiling range that are used as paint thinners, cleaners, or solvents. These products are refined to a specified flash point. Special naphthas include all commercial hexane and cleaning solvents conforming to ASTM Specification D1836 and D484, respectively. Naphthas to be blended or marketed as motor gasoline or aviation gasoline, or that are to be used as petrochemical and synthetic natural gas (SNG) feedstocks are excluded.',
		],
	},
	{
		title: 'Singapore International Money Exchange (SIMEX)',
		content: ['A futures exchange in Singapore trading fuel oil.'],
	},
	{
		title: 'Specific Gravity',
		content: [
			'The comparable weight of different grades of crude oil. A lower number reflects a sweeter, lighter grade of crude oil more conducive to gasoline production.',
		],
	},
	{
		title: 'Speculator',
		content: [
			'Industry or non-industry participant who eyes a futures or options profit by anticipating a future price movement or changing relationship. A speculator might purchase 30 Dec. heating oil contracts at 50cts/gal when he judges that technical or fundamental factors are likely to drive the prices higher.',
		],
	},
	{
		title: 'Shale',
		content: [
			'A very fine-grained sedimentary rock that is formed by the consolidation of clay, mud or silt and that usually has a finely stratified or laminated structure. Certain shale formations, such as the Eagle Ford and the Barnett, contain large amounts of oil and natural gas.',
		],
	},
	{
		title: 'Splash Blend',
		content: [
			'To blend or mix two or more products together by adding one product to the other such as ethanol to gasoline in a cargo tank compartment or even a service station underground tank. Spot: A deal for supply wherein the price is negotiated between the buyer and the seller, and the supply commitment varies.',
		],
	},
	{
		title: 'Spot Margin',
		content: [
			'Additional funds required to be on hand as a contract approaches its delivery date. When a NYMEX contract becomes the spot month (the first month on the board), margin requirements are increased automatically by the NYMEX. They increase again five days prior to the last trading day, with the intent of encouraging players to move out of the delivery month. Spot Market: High volume (25,000 to 300,000 bbls) contractual agreements between oil companies dictating delivery of petroleum products or crude oil in the near future for an established sales price. Since this market reacts quickly, and is an alternative to wholesale sales, it provides a good indication of the direction of wholesale price trends. Also referred to as Cash Market.',
		],
	},
	{
		title: 'Spot Price',
		content: ['The current value of any product on a volume basis.'],
	},
	{
		title: 'Spreads',
		content: [
			'In futures markets, applies to the difference between prices of futures contracts for different delivery months, or to the difference in prices for different commodities. Spread traders try to capitalize on likely fluctuations in these relationships, and initial spread margins are often considerably lower than for outright positions.',
		],
	},
	{
		title: 'Squeeze',
		content: [
			'A trading situation where a lack of actual deliverable product exists. Traders who are short must buy back positions in a rapidly rising market.',
		],
	},
	{
		title: 'Standard Industrial Classification (SIC) code',
		content: [
			'A classification of establishments by type of activity in which they are engaged: for the purpose of facilitating the collection, tabulation, presentation and analysis of data relating to establishments (e.g. SIC 421 Trucking & Courier Services, Except Air).',
		],
	},
	{
		title: 'Standard OPIS Display',
		content: [
			'Shows one price per product per supplier for all suppliers in that rack city. OPIS uses the primary terminal for suppliers with multiple terminals to avoid skewing the OPIS average for benchmarking purposes.',
		],
	},
	{
		title: 'Still Gas (refinery gas)',
		content: [
			'Any form or mixture of gases produced in refineries by distillation, cracking, reforming, and other processes. The principal constituents are methane, ethane, ethylene, normal butane, butylenes, propane, propylene, etc. Still gas is used as a refinery fuel and a petrochemical feedstock. The conversion factor is 6 million BTU’s per fuel oil equivalent barrel.',
		],
	},
	{
		title: 'Stock Change',
		content: [
			'The difference between stocks at the beginning of the reporting period and stocks at the end of the reporting period. Note: A negative number indicates a decrease (i.e., a drawdown) in stocks and a positive number indicates an increase (i.e., a buildup) in stocks during the reporting period.',
		],
	},
	{
		title: 'Stop Limit',
		content: [
			'A limit order to purchase (sell) above (or below in the case of a sell order) if a certain “stop price” is reached. Stop limit orders to buy or sell are often a key feature when critical technical levels are breached or surpassed in the market.',
		],
	},
	{
		title: 'Stop Loss',
		content: [
			'A futures order designed to close out a losing position when the price reaches the specified level.',
		],
	},
	{
		title: 'Stove Oil',
		content: [
			'Canadian term used to describe kerosene. Stove oil in Canada is the equivalent of U.S. low-sulfur No. 1 oil or kerosene.',
		],
	},
	{
		title: 'Straddle (spread)',
		content: [
			'The purchase of one futures month against the sale of another futures month of the same commodity. A straddle trade is based on a price relationship between the two months.',
		],
	},
	{
		title: 'Strategic Petroleum Reserve (SPR)',
		content: [
			'Petroleum stocks maintained by the Federal Government for use during periods of major supply interruption.',
		],
	},
	{
		title: 'Sub-Octane',
		content: [
			'Usually applies to a gasoline that does not meet the 87 octane standard which most suppliers mandate for regular unleaded distinction. Sub-octanes are typically utilized by those using oxygenated components.',
		],
	},
	{
		title: 'Sulfur',
		content: [
			'A yellowish nonmetallic element, sometimes known as “brimstone.” It is present at various levels of concentration in many fossil fuels whose combustion releases sulfur compounds that are considered harmful to the environment. Some of the most commonly used fossil fuels are categorized according to their sulfur content, with lower sulfur fuels usually selling at a higher price. Note: No. 2 Distillate fuel is currently reported as having either a 0.05% or lower sulfur level for on-highway vehicle use or a greater than 0.05% sulfur level for off-highway use, home heating oil, and commercial and industrial uses. This also includes Ultra Low Sulfur Diesel (<15 ppm sulfur). Residual fuel, regardless of use, is classified as having either no more than 1% sulfur or greater than 1% sulfur. Coal is also classified as being low-sulfur at concentrations of 1% or less or high-sulfur at concentrations greater than 1%.',
		],
	},
	{
		title: 'Supply',
		content: [
			'The components of petroleum supply are field production, refinery production, imports, and net receipts when calculated on a PAD District basis.',
		],
	},
	{
		title: 'Support Area',
		content: [
			'A price level where a descending price movement is likely to encounter resistance.',
		],
	},
	{
		title: 'Swap',
		content: [
			'An exchange of obligations to pay each other a defined amount based upon the relative values of a fixed price and specific index. Typically, one part receives a fixed price in exchange for an indexed (escalating) price. Settlement is in cash and at specified times. Example: If party A receives a fixed price and party B receives OPIS low, then party A collects the difference when OPIS is above the fixed price, and party B collects when it is lower.',
		],
	},
	{
		title: 'Social Life Cycle Analysis (S-LCA)',
		content: [
			'A methodology for assessing internalities and externalities of the production of goods and services based on social and socioeconomic indicators.',
		],
	},
	{
		title: 'Sour gas',
		content: [
			'Sour gas is natural gas or any other gas containing significant amounts of hydrogen sulfide (H2S). Spacing  The distance between wells producing from the same reservoir. Spacing is often expressed in terms of acres (e.g. 80-acre spacing) and is often established by regulatory agencies.',
		],
	},
	{
		title: 'Steam-assisted gravity drainage (SAGD)',
		content: [
			'A process used to recover bitumen that is too deep to mine. A pair of horizontal wells is drilled from a central well pad. In a plant nearby, steam generators heat water and transform it into steam. The steam then travels through above-ground pipelines to the wells. It enters the ground via the steam injection well and heats the bitumen to a temperature at which it can flow by gravity into the producing well. The resulting bitumen and condensed steam emulsion is then piped from the producing well to the plant, where it is separated and treated. The water is recycled for generating new steam.',
		],
	},
	{
		title: 'Sweet gas',
		content: ['Natural gas that contains little or no hydrogen sulfide.'],
	},
	{
		title: 'TCF',
		content: ['One trillion cubic feet of natural gas.'],
	},
	{
		title: 'TAME (tertiary amyl methyl ether) (CH3)2(C2H5)COCH3:',
		content: [
			'An oxygenate blend stock formed by the catalytic etherfication of isoamylene with methanol.',
		],
	},
	{
		title: 'Tank Farm',
		content: [
			'An installation used by gathering and trunk pipeline companies, crude oil producers, and terminal operators (except refineries) to store crude oil.',
		],
	},
	{
		title: 'Tanker And Barge',
		content: [
			'Vessels that transport crude oil or petroleum products. Data are reported for movements between PAD Districts from a PAD District to the Panama Canal or from the Panama Canal to a PAD District.',
		],
	},
	{
		title: 'TBA (tertiary butyl alcohol) (CH3)3COH',
		content: [
			'An alcohol primarily used as a chemical feedstock, a solvent or feedstock for isobutylene production for MTBE, produced as a co-product of propylene oxide production or by direct hydration of isobutylene. Tariff: A schedule of rates that a common carrier pipeline is permitted to charge to transport petroleum products or crude.',
		],
	},
	{
		title: 'Technical Analysis',
		content: [
			'Analysis primarily derived from studying historical buying/selling patterns in futures and spot markets and attempting to predict with reasonable certainty the probability of mimicking those movements again. Technical analysis is often very sophisticated and is probably the single most critical factor in determining day-to-day futures price movements.',
		],
	},
	{
		title: 'TET',
		content: [
			'The designation used within the industry to specify that product traded in the original TET facility currently owned by the Energy Transfer Partners LP and Regency Energy Partners LP joint venture, (LST), at Mont Belvieu, Texas.',
		],
	},
	{
		title: 'Temporary Voluntary Allowance (TVA)',
		content: [
			'A discount given to a jobber, often when the supplier has a surplus and is likely to run down inventories, or when retail profit pressure requires temporary rack discounting.',
		],
	},
	{
		title: 'Tertiary Storage',
		content: [
			'The petroleum storage tanks of end users, such as vehicle gasoline tanks or home heating oil storage.',
		],
	},
	{
		title: 'Thermal Crackings',
		content: [
			'A refining process in which heat and pressure are used to break down, rearrange or combine hydrocarbon molecules. Thermal cracking includes visbreaking, fluid coking, delayed coking and other thermal cracking processes.',
		],
	},
	{
		title: 'Third Structure Tax',
		content: [
			'Any tax on road users other than registration fees or fuel taxes (e.g. Ton-mile tax).',
		],
	},
	{
		title: 'Time Value',
		content: [
			'The part of an options premium which reflects the excess over the intrinsic value, or which may reflect the entire premium if there is no intrinsic value. A call option for 60cts/gal oil in a 58cts/gal market that is trading at a premium of 2cts/ gal would represent a case where the entire premium is attributable to time value. Time value generally declines as an options contract nears expiration. It can represent the lion’s share of the premium at great distances from expiration.',
		],
	},
	{
		title: 'Toluene (C6H5CH3)',
		content: [
			'Colorless liquid of the aromatic group of petroleum hydrocarbons, made by the catalytic reforming of petroleum naphthas containing methyl cyclohexane. A high-octane gasoline-blending agent, solvent, and chemical intermediate, base for TNT. Ton (metric ton): The unit of measurement for crude or products outside of the United States. On average, there are seven barrels of crude per metric ton.',
		],
	},
	{
		title: 'Ton-Mile',
		content: [
			'The movement of one ton of freight a distance of one mile. Ton-miles are computed by multiplying the weight in tons of each shipment transported by the distance hauled.',
		],
	},
	{
		title: 'Ton-Mile Tax',
		content: [
			'A tax calculated by measuring the weight of each truck for each trip. The gross weight is assigned a tax rate which is multiplied by the miles of travel.',
		],
	},
	{
		title: 'Traders',
		content: [
			'Buyers and sellers of large quantities of petroleum products. They use the spot markets as a basis for their deals. Traders differ from brokers in that they actually take title to the product. Trailer: A vehicle designed without motive power, to be drawn by another vehicle.',
		],
	},
	{
		title: 'Transit Time',
		content: [
			'The period of time designated by a pipeline company for petroleum products to move from one destination to another to be available at the destination.',
		],
	},
	{
		title: 'Transmix',
		content: [
			'Also known as interface, the product removed from a pipeline system between two separate product batches that cannot be blended with the first or second product.',
		],
	},
	{
		title: 'Trigger Deals',
		content: [
			'Futures-related or derivative instrument which allows a marketer to lock into a price relationship, but gives him the opportunity to set the absolute price at a later date. A supplier might sell a trigger deal to a heating oil marketer whereby the marketer is guaranteed product at 2cts/gal over the Dec. futures price for No. 2 oil. The marketer has until an agreed upon date to “pull the trigger” to set the absolute value of the transaction.',
		],
	},
	{
		title: 'Truck Tonnage',
		content: ['The weight of freight in tons transported by truck.'],
	},
	{
		title: 'Truckload (TL)',
		content: [
			'Quantity of freight required to fill a truck. When used in connection with freight rates, the quantity of freight necessary to qualify a shipment for a truckload rate. Usually in excess of 10,000 pounds.',
		],
	},
	{
		title: 'Turnaround',
		content: [
			'Originally, this term applied to the periodic inspection and maintenance of an oil refinery. It now applies to any shutdown, slowdown or operational problem brought upon by refinery maintenance. Turnarounds are then said to be “planned” or “unplanned.”.',
		],
	},
	{
		title: 'Tight gas',
		content: [
			'Natural gas produced from relatively impermeable rock. Getting tight gas out usually requires enhanced technology applications like hydraulic fracturing. The term is generally used for reservoirs other than shale.',
		],
	},
	{
		title: 'Total Recordable Rate (TRR)',
		content: [
			'The total recordable rate is a measure of the rate of recordable cases, normalized per 100 workers per year. The factor is derived by multiplying the number of recordable injuries in a calendar year by 200,000 (100 employees working 2,000 hours per year) and dividing this value by the total man hours actually worked in the year.',
		],
	},
	{
		title: 'Total Shareholder Return (TSR)',
		content: [
			'Represents share price appreciation and dividends returned to shareholders over a period. It is calculated as follows: [(stock price at the end of the period) – (stock price at the start of the period) + (dividends paid during the calculation period) ÷ (stock price at the start of the period)].',
		],
	},
	{
		title: 'Unaccounted for Crude Oil',
		content: [
			'Represents the arithmetic difference between the calculated supply and the calculated disposition of crude oil. The calculated supply is the sum of crude oil production plus imports minus changes in crude oil stocks. The calculated disposition of crude oil is the sum of crude oil input to refineries, crude oil exports, crude oil burned as fuel, and crude oil losses.',
		],
	},
	{
		title: 'Unaccounted for gas (UFG)',
		content: ['Gas that is lost through leakage or errors in measurement.'],
	},
	{
		title: 'United Arab Emirates (UAE)',
		content: [
			'An OPEC country which is a confederation of small Arab States of which, Dubai and Abu Dhabi are the principal oil producers.',
		],
	},
	{
		title: 'Ultra Large Crude Carrier (ULCC)',
		content: [
			'The largest category of tanker, generally holding at least 3.5 million barrels of product. Unbranded: A supply arrangement with a supplier that is usually not contractual, and does not usually guarantee a specific amount of supply and involves product not marked by a proprietary branded additive package.',
		],
	},
	{
		title: 'Unbranded Average',
		content: [
			'An average of all unbranded suppliers, denoted with a (u) in the display. Calculated for gross or net.',
		],
	},
	{
		title: 'Unfinished Oils',
		content: [
			'All oils requiring further processing, except those requiring only mechanical blending. Unfinished oils are produced by partial refining of crude oil and include naphthas and lighter oils, kerosene and light gas oils, heavy gas oils, and residuum.',
		],
	},
	{
		title: 'Unfractionated Streams',
		content: [
			'Mixtures of unsegregated natural gas liquid components excluding those in plant condensate. This product is extracted from natural gas.',
		],
	},
	{
		title: 'Upstream',
		content: [
			'Term applying to functions or facilities close to the wellhead. Drilling and production are generally upstream processes in the oil patch while refining and marketing are downstream.',
		],
	},
	{
		title: 'Unconventional reservoirs',
		content: [
			'Reservoirs with permeability so low (generally less than 0.1 millidarcy) that horizontal hydraulically fractured stimulated wells or other advanced completion techniques must be utilized to extract hydrocarbons at commercial rates. Shale reservoirs such as the Eagle Ford and Barnett, as well as tight reservoirs like the Bakken and Three Forks, both are examples of unconventional reservoirs.',
		],
	},
	{
		title: 'Undeveloped acreage',
		content: [
			'Acreage on which wells have not been drilled or completed to a point that would permit the production of commercial quantities of oil and gas regardless of whether or not the acreage contains proved reserves.',
		],
	},
	{
		title: 'Unit',
		content: [
			'The joining of interests in a reservoir or field to provide for development and operations without regard to separate property interests. Also, the area covered by a unitization agreement.',
		],
	},
	{
		title: 'Unbundled rates',
		content: [
			'Rates charged for the specific services that make up energy provision.',
		],
	},
	{
		title: 'Unbundled services',
		content: [
			'Prior to deregulation of the US energy industry, most energy customers were provided with electrical service as an integrated package. Energy customers in Canada still receive service in this fashion. As more competition emerges in the energy industry and more companies become involved in the production and delivery of energy, separate charges for each facet of electrical supply and service is billed as a distinct line item charge on a customer’s invoice.',
			'Customers no longer pay for a group of services represented as a single service. Instead they pay for a multitude of services (energy generation, transmission, distribution, and perhaps many more depending on how energy is billed in a given region), all of which are required for electrical service. When services are charged in this way, they are referred to as unbundled.',
		],
	},
	{
		title: 'Unbundling',
		content: [
			'The separation of component parts of a previously unified product or service usually provided by a single party into distinct products or services each provided by different parties. In the energy industry, functional unbundling of services is often accompanied by the insistence on a structural unbundling of a vertically integrated utility that formerly provided all of those services. A vertically integrated utility is often required to choose one component service in which it will specialise, and restructure or divest itself of all parts of its business related to services in which it will not participate. The unbundling of a utility’s divisions handling these component services is referred to as structural unbundling.',
		],
	},
	{
		title: 'Underlying',
		content: [
			'The variable on which a futures, option, or other derivative contract is based.',
		],
	},
	{
		title: 'Uniform system of accounts',
		content: [
			'Prescribed financial rules and regulations established by the Federal Energy Regulatory Commission for utilities subject to its jurisdiction under the authority granted by the Federal Power Act.',
		],
	},
	{
		title: 'Uninterruptible power supply (UPS)',
		content: [
			'A type of backup system, usually battery-powered, used to ensure continuous availability of power in the event of an interruption of service. These are most commonly used with PCs to provide emergency backup energy in the event of an unplanned outage or brief interruption of power. In the case of momentary power outages, UPS allows operators to work through the outage by preventing the rebooting that would otherwise occur with even a split-second of interrupted power. In the case of longer outages, the UPS should provide enough energy to allow equipment operators (usually computer operators) sufficient time to properly save their data and shut down their equipment, and perhaps even continue working through the outage for several minutes to several hours. (The length of time a UPS can keep a PC functioning depends on the storage capacity of the UPS and the energy consumption of the PC.) Perhaps most importantly, UPS protects operators against the loss of data that commonly occurs when a PC reboots or shuts off without warning.',
		],
	},
	{
		title: 'Unit commitment',
		content: [
			'• The commitment of generating units to the production of energy.',
			'• Involves determining that generators in a given facility will be committed to meet the expected load over the near term. Unit commitment is usually scheduled a day in advance, and a generator is said to be committed once it is started. Nearly all generators are rotating devices, so a committed generator is often referred to as a spinning generator. A committed unit can remain offline indefinitely without producing energy.',
		],
	},
	{
		title: 'Unit energy consumption (UEC)',
		content: [
			'The annual amount of energy that is used by the electrical device or appliance.',
		],
	},
	{
		title: 'Universal service',
		content: [
			'• A base level of electrical service, usually a bundle of services required to meet basic residential requirements, which is used as a standard, entry-level package for customers and is typically made available to all customers regardless of energy demand. May also be referred to as standard offer.',
			'• A policy that guarantees universal access to a basic package of electrical services at an affordable rate. It is called universal service because electric service is considered a necessity for all households in North America.',
		],
	},
	{
		title: 'Vacuum Distillation',
		content: [
			'Distillate under reduced pressure, which lowers the boiling temperature of the liquid being distilled. This technique prevents cracking or decomposition of the charge stock.',
		],
	},
	{
		title: 'Variation Margin',
		content: [
			'The unrealized loss in a position. Traders must post these funds to ensure that their initial margin is restored to its starting balance.',
		],
	},
	{
		title: 'Vehicle-Miles',
		content: [
			'A measurement of the total miles traveled by all vehicles in an area. Generally applies to intercity movements only.',
		],
	},
	{
		title: 'Very Large Crude Carrier (VLCC)',
		content: [
			'Term used to describe ocean-going tanker hauling from 1.5 million to 2.5 million barrels of product.',
		],
	},
	{
		title: 'Visbreaking',
		content: [
			'A thermal cracking process in which heavy atmospheric or vacuum-still bottoms are cracked at moderate temperatures to increase production of distillate products and reduce viscosity of the distillation residues.',
		],
	},
	{
		title: 'Volatile Organic Compounds (VOCs)',
		content: [
			'Volatile Organic Compounds are a combination of chemical pollutants that form ozone or smog. The Clean Air Act was designed in part to reduce VOCs in gasoline in order to reduce ozone pollution from gasoline exhaust and emissions. OPIS designates certain products as VOC during portions of the spring/ summer.',
		],
	},
	{
		title: 'Volatility',
		content: [
			'The degree to which an oil product will vaporize, or turn from liquid to gas, when heated. Also, refers to the degree of price movement for oil products in the futures or physical markets. Volume: The number of transactions made on a futures exchange that would consist of a purchase and a matching sale.',
		],
	},
	{
		title: 'Waterflood',
		content: [
			'An improved oil recovery technique that involves injecting water into a producing reservoir to enhance movement of oil to producing wells.',
		],
	},
	{
		title: 'Watt',
		content: [
			'The electrical unit of power. The rate of energy transfer equivalent to 1 ampere flowing under a pressure of 1 volt at unity power factor.',
		],
	},
	{
		title: 'WACOG',
		content: ['Weighted average cost of gas.'],
	},
	{
		title: 'Wax',
		content: [
			'A solid or semi-solid material consisting of a mixture of hydrocarbons obtained or derived from petroleum fractions, or through a Fischer-Tropsch type process, in which the straight-chained paraffin series predominates. This includes all marketable wax, whether crude or refined, with a congealing point (ASTM D 938) between 100 and 200 degrees Fahrenheit and a maximum oil content (ASTM D 3235) of 50 weight percent.',
		],
	},
	{
		title: 'Wellbore',
		content: [
			'The hole drilled by a drilling rig to explore for or develop oil and/or natural gas. Also referred to as a well or borehole.',
		],
	},
	{
		title: 'Wet gas',
		content: [
			'Produced gas that contains natural gas liquids. Working interest  The right granted to the lessee of a property to explore for, produce and own oil, gas or other minerals. The working interest owners bear the exploration, development and operating costs.',
		],
	},
	{
		title: 'Weight-Distance Tax',
		content: [
			'A tax basing the fee per mile on the registered gross weight of the vehicle. Total tax liability is calculated by multiplying this rate times miles traveled.',
		],
	},
	{
		title: 'Wet Barrel',
		content: [
			'Industry term to specify actual physical barrels, often in a very prompt timeframe. Contrasts with paper bbl, where title is not backed up with actual physical material.',
		],
	},
	{
		title: 'Wholesale Netbacks',
		content: ['See netbacks.'],
	},
	{
		title: 'West Texas Intermediate (WTI)',
		content: [
			'The benchmark grade of domestic crude, traded on the NYMEX and stored at Cushing, Oklahoma.',
		],
	},
	{
		title: 'Working Storage Capacity',
		content: [
			'The difference in volume between the maximum safe fill capacity and the quantity below which pump suction is ineffective (bottoms).',
		],
	},
	{
		title: 'Weather derivatives',
		content: [
			'Forward instruments used to hedge against or speculate on weather. Virtually all of the instruments are based on degree-days, though precipitation swaps and sunshine options are among other possible instruments.',
		],
	},
	{
		title: 'West Texas Intermediate (WTI)',
		content: [
			'US crude oil used as a benchmark for pricing much of the world’s crude oil production.',
		],
	},
	{
		title: 'Wheeling',
		content: [
			'The delivery, and more specifically refers to delivery of energy across transmission systems. In some contexts it is used synonymously with transmission, although this use is somewhat misleading since energy can be wheeled through distribution systems as well. Wheeling across transmission systems is generally referred to as wholesale wheeling, since wholesale transactions are nearly always limited to sales made on the transmission grid. Any movement of energy between parts of the system, or within the same part of the system, that involves a change of ownership for the energy. Wholesale wheeling is the sale and delivery of energy among buyers and sellers in the wholesale market, usually to parties who take delivery of the energy on the transmission system. When a utility or energy distribution company delivers, or wheels, energy from the transmission system to an end-use customer, it is referred to as retail wheeling. When a customer who also generates energy produces energy at one site, transports it across someone else’s facilities and consumes it at another site, it is referred to as self-service wheeling.',
		],
	},
	{
		title: 'Wholesale',
		content: [
			'The sale of any commodity to a party who intends to resell that commodity to other parties is referred to as a wholesale transaction. In the energy industry, wholesaling is distinguished from retailing primarily by the regulatory environment that governs wholesale transactions and the distances travelled by the energy. Interstate wholesale transactions fall under Federal Energy Regulatory Commission regulations in the United States, and even most noncustomer sales within the same state are referred to within the industry as retail sales. Wholesale energy sales can be made between producers, marketers, brokers, utility companies and select high-volume end-use customers. The most common form of wholesale energy transaction made between energy producers or marketers and utility companies who serve the general public.',
		],
	},
	{
		title: 'Winter peak',
		content: [
			'A period at the beginning of the year, usually between December 1 and March 30, when the use of heating systems creates the strongest demand for energy in areas with cold winter weather.',
		],
	},
	{
		title: 'X-Grade',
		content: [
			'Magellan Pipeline terminology for ultra-low-sulfur diesel fuel.',
		],
	},
	{
		title: 'Xetra',
		content: [
			'The Xetra system is one of the trading systems used on the EEX Spot Markets.',
		],
	},
	{
		title: 'Xylenes (C6H4(CH3)2)',
		content: [
			'Colorless liquid of the aromatic group of hydrocarbons made the catalytic reforming of certain naphthenic petroleum fractions. Used as high-octane motor and aviation gasoline blending agents, solvents, chemical intermediates. Isomers are metaxylene, orthoxylene, paraxylene.',
		],
	},
	{
		title: 'YTD',
		content: ['Year-to-date.'],
	},
	{
		title: 'Yield',
		content: [
			'The interest rate that will make the net present value of the cashflows from an investment equal to the price (or cost) of the investment. The net present value is the present value of future cashflows, discounted at the present cost of capital. The current yield relates the annual coupon yield to the market price by dividing the coupon by the price divided by 100, neglecting the time value of money or potential capital gains and losses. The simple yield-to-maturity takes into account the effect of the capital gained or lost at maturity, as well as the current yield.',
		],
	},
	{
		title: 'Y-Grade',
		content: [
			'Magellan Pipeline terminology for No. 1 fuel oil. The feedstocks that are sent to a fractionator in order to extract gas liquids.',
		],
	},
	{
		title: 'Yield curve',
		content: [
			'A graph of the term structure of interest rates. It is usually given in terms of the spot yields on bonds with different maturities but the same risk factors (such as creditworthiness of issuer), plotted against maturity. In general, yields will increase with maturity and with the riskiness of the debt. Yield curves can be plotted for default-free bonds; bonds that may default will fall on another yield curve at some spread to the default-free curve.',
		],
	},
	{
		title: 'Zero-cost option',
		content: [
			'An option strategy under that one option is purchased by simultaneously selling another option of equal value.',
		],
	},
];
